/* eslint-disable no-unused-vars */

import { calculateCrossSlopeFromRadius } from "utilities/genericRoadUtilities/calculateCrossSlopeFromRadius";
import { calculateSpeedProfileAddition } from "utilities/genericRoadUtilities/calculateSpeedProfileAddition";
import { calculateSuperelevationRunoffLength } from "utilities/genericRoadUtilities/calculateSuperelevationRunoffLength";

export const calculateSuperelevationFromHorizontalData = ({
    speedlimit,
    geometry,
    designClass,
    normalCrossSlope,
    wheelbase,
    relativeVerticalSpeed,
    speedAddition
}) => {

    let leftSide = [];
    let rightSide = [];

    let tempLeftSide = [];
    let tempRightSide = [];

    let tempGeometry = [];
    for(let i = 0; i<geometry.length; i++)
    {
        if(tempGeometry.length === 0)
        {
            tempGeometry.push(geometry[i]);
            continue;
        }
        if(geometry[i].type === "Rettlinje" && tempGeometry[tempGeometry.length-1].type === "Rettlinje")
        {
            tempGeometry[tempGeometry.length-1].endStationing = geometry[i].endStationing;
            tempGeometry[tempGeometry.length-1].length += geometry[i].length;
        }
        else if(geometry[i].type === "Sirkelbue" && tempGeometry[tempGeometry.length-1].type === "Sirkelbue")
        {
            if(geometry[i].firstRadius === tempGeometry[tempGeometry.length-1].firstRadius)
            {
                tempGeometry[tempGeometry.length-1].endStationing = geometry[i].endStationing;
                tempGeometry[tempGeometry.length-1].length += geometry[i].length;
            }
            else
            {
                tempGeometry.push(geometry[i]);
            }
        }
        else
        {
            tempGeometry.push(geometry[i]);
        }
    }

    geometry = tempGeometry;

    // #region inserting points
    if(geometry.length >= 3)
    {
        for(let i = 1; i<geometry.length-1; i++)
        {
            let O1 = geometry[i-1];
            let O2 =geometry[i];
            let O3 =geometry[i+1];

            if(O1.type === "Rettlinje" && O2.type === "Klotoide" && O3.type === "Klotoide")
            {
                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.secondRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                if(O2.firstRadius === 0 && O2.secondRadius !== 0 && O2.secondRadius === O3.firstRadius)
                {
                    if(O2.firstRadius === 0 && O2.secondRadius > 0)
                    {
                        if(O2.length >= L0 + Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing, crossSlope: -normalCrossSlope, speed: speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius)});
                            leftSide.push({stationing: O2.startStationing + 2 * L0, crossSlope: normalCrossSlope, speed: speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius)});
                            leftSide.push({stationing: O2.endStationing, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.secondRadius), speed: speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius)});

                            rightSide.push({stationing: O2.startStationing, crossSlope: -normalCrossSlope});
                            rightSide.push({stationing: O2.startStationing + 2 * L0, crossSlope: -normalCrossSlope});
                            rightSide.push({stationing: O2.endStationing, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});
                        }
                        else
                        {
                            leftSide.push({stationing: O2.startStationing, crossSlope: 0});

                            if(O2.startStationing + L0 > O2.startStationing && O2.startStationing + L0 < O2.endStationing)
                                rightSide.push({stationing: O2.startStationing + L0, crossSlope: normalCrossSlope});

                            leftSide.push({stationing: O2.endStationing, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});

                            rightSide.push({stationing: O2.startStationing, crossSlope: -normalCrossSlope});
                            
                            if(O2.startStationing + L0 > O2.startStationing && O2.startStationing + L0 < O2.endStationing)
                                rightSide.push({stationing: O2.startStationing + L0, crossSlope: -normalCrossSlope});

                            rightSide.push({stationing: O2.endStationing, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});
                        }
                    }
                    else if(O2.firstRadius === 0 && O2.secondRadius < 0)
                    {
                        if(O2.length >= L0 + Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing, crossSlope: -normalCrossSlope});

                            if(O2.startStationing + 2 * L0 > O2.startStationing && O2.startStationing + 2 * L0 < O2.endStationing)
                                leftSide.push({stationing: O2.startStationing + 2 * L0, crossSlope: -normalCrossSlope});

                            leftSide.push({stationing: O2.endStationing, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});

                            rightSide.push({stationing: O2.startStationing, crossSlope: -normalCrossSlope});

                            if(O2.startStationing + 2 * L0 > O2.startStationing && O2.startStationing + 2 * L0 < O2.endStationing)
                                rightSide.push({stationing: O2.startStationing + 2 * L0, crossSlope: normalCrossSlope});

                            rightSide.push({stationing: O2.endStationing, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});
                        }
                        else
                        {
                            leftSide.push({stationing: O2.startStationing, crossSlope: -normalCrossSlope});

                            if(O2.startStationing + L0 > O2.startStationing && O2.startStationing + L0 < O2.endStationing)
                                leftSide.push({stationing: O2.startStationing + L0, crossSlope: -normalCrossSlope});

                            leftSide.push({stationing: O2.endStationing, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});

                            rightSide.push({stationing: O2.startStationing, crossSlope: 0});

                            if(O2.startStationing + L0 > O2.startStationing && O2.startStationing + L0 < O2.endStationing)
                                rightSide.push({stationing: O2.startStationing + L0, crossSlope: normalCrossSlope});

                            rightSide.push({stationing: O2.endStationing, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.secondRadius)});
                        }
                    }
                }
            }
            else if(O1.type === "Rettlinje" && O2.type === "Klotoide" && O3.type === "Sirkelbue")
            {
                let e1 =  calculateCrossSlopeFromRadius(designClass, O2.secondRadius);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.secondRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.secondRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                let A1 = {};
                let A2 = {};
                let A3 = {};

                let B1 = {};
                let B2 = {};
                let B3 = {};

                if(O2.secondRadius > 0)
                {
                    if(O2.length >= L0 + Lmin)
                    {
                        A1 = {stationing: O2.startStationing, crossSlope: -normalCrossSlope};
                        A2 = {stationing: O2.startStationing + L0, crossSlope: 0};
                        A3 = {stationing: O2.endStationing, crossSlope: e1};

                        B1 = {stationing: O2.startStationing, crossSlope: -normalCrossSlope};
                        B2 = {stationing: O2.startStationing + L0, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.endStationing, crossSlope: -e1};
                    }
                    if(O2.length < L0 + Lmin)
                    {
                        A1 = {stationing: O2.startStationing - L0, crossSlope: -normalCrossSlope};
                        A2 = {stationing: O2.startStationing, crossSlope: 0};
                        A3 = {stationing: O2.endStationing, crossSlope: e1};

                        B1 = {stationing: O2.startStationing - L0, crossSlope: -normalCrossSlope};
                        B2 = {stationing: O2.startStationing, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.endStationing, crossSlope: -e1};
                    }
                }
                else if(O2.secondRadius < 0)
                {
                    if(O2.length >= L0 + Lmin)
                    {
                        A1 = {stationing: O2.startStationing, crossSlope: -normalCrossSlope};
                        A2 = {stationing: O2.startStationing + L0, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.endStationing, crossSlope: -e1};

                        B1 = {stationing: O2.startStationing, crossSlope: -normalCrossSlope};
                        B2 = {stationing: O2.startStationing + L0, crossSlope: 0};
                        B3 = {stationing: O2.endStationing, crossSlope: e1};
                    }
                    if(O2.length < L0 + Lmin)
                    {
                        A1 = {stationing: O2.startStationing - L0, crossSlope: -normalCrossSlope};
                        A2 = {stationing: O2.startStationing, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.endStationing, crossSlope: -e1};

                        B1 = {stationing: O2.startStationing - L0, crossSlope: -normalCrossSlope};
                        B2 = {stationing: O2.startStationing, crossSlope: 0};
                        B3 = {stationing: O2.endStationing, crossSlope: e1};
                    }
                }

                if(O2.length >= L0 + Lmin) leftSide.push(A1, A2, A3);
                if(O2.length < L0 + Lmin) leftSide.push(A2, A3);

                if(O2.length >= L0 + Lmin) rightSide.push(B1, B2, B3);
                if(O2.length < L0 + Lmin) rightSide.push(B2, B3);

            }
            else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue" && O3.type === "Rettlinje")
            {
                let objectSpeed = speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius);
                
                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                if(O2.firstRadius > 0)
                {   
                    if(O2.startStationing + 0.4 * Lmin < O2.endStationing - 0.4 * Lmin)
                    {
                        if(L0 === Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: normalCrossSlope});
                            leftSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: normalCrossSlope});

                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -normalCrossSlope});
                            rightSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 >= 0.6 * Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope});
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope});

                            rightSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope});
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 < 0.6 * Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});

                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                        }
                    }
                    else if(O2.startStationing + 0.4 * Lmin === O2.endStationing - 0.4 * Lmin)
                    {
                        if(L0 === Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: normalCrossSlope});

                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 >= 0.6 * Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope});
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope});

                            rightSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope});
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 < 0.6 * Lmin)
                        {
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});

                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                        }
                    }
                    else if(O2.startStationing + 0.4 * Lmin > O2.endStationing - 0.4 * Lmin)
                    {
                        if(L0 === Lmin)
                        {
                            leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                            rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 >= 0.6 * Lmin)
                        {
                            if(O2.startStationing - 0.6 * Lmin + L0 < O2.endStationing + 0.6 * Lmin - L0)
                            {
                                leftSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope});
                                leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                                leftSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope});

                                rightSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope});
                                rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -(calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                                rightSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope});
                            }
                            else if(O2.startStationing - 0.6 * Lmin + L0 >= O2.endStationing + 0.6 * Lmin - L0)
                            {
                                leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                                rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -(calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)}); 
                            }
                        }
                        else if(L0 < 0.6 * Lmin)
                        {
                            leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                            rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -(calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)}); 
                        }
                    }
                }
                else if(O2.firstRadius < 0)
                {
                    if(O2.startStationing + 0.4 * Lmin < O2.endStationing - 0.4 * Lmin)
                    {
                        if(L0 === Lmin)
                        {
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: normalCrossSlope});
                            rightSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: normalCrossSlope});

                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -normalCrossSlope});
                            leftSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 >= 0.6 * Lmin)
                        {
                            rightSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope});
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope});

                            leftSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope});
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 < 0.6 * Lmin)
                        {
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});

                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                        }
                    }
                    else if(O2.startStationing + 0.4 * Lmin === O2.endStationing - 0.4 * Lmin)
                    {
                        if(L0 === Lmin)
                        {
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: normalCrossSlope});

                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 >= 0.6 * Lmin)
                        {
                            rightSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope});
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            rightSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope});

                            leftSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope});
                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                            leftSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 < 0.6 * Lmin)
                        {
                            rightSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});

                            leftSide.push({stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -calculateCrossSlopeFromRadius(designClass, O2.firstRadius)});
                        }
                    }
                    else if(O2.startStationing + 0.4 * Lmin > O2.endStationing - 0.4 * Lmin)
                    {
                        if(L0 === Lmin)
                        {
                            rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                            leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -normalCrossSlope});
                        }
                        else if(L0 >= 0.6 * Lmin)
                        {
                            if(O2.startStationing - 0.6 * Lmin + L0 < O2.endStationing + 0.6 * Lmin - L0)
                            {
                                rightSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope});
                                leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                                rightSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope});

                                leftSide.push({stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope});
                                leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -(calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                                leftSide.push({stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope});
                            }
                            else if(O2.startStationing - 0.6 * Lmin + L0 >= O2.endStationing + 0.6 * Lmin - L0)
                            {
                                rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                                leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -(calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)}); 
                            }
                        }
                        else if(L0 < 0.6 * Lmin)
                        {
                            rightSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: (calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)});
                            leftSide.push({stationing: 0.5 * O2.startStationing + 0.5 * O2.endStationing, crossSlope: -(calculateCrossSlopeFromRadius(designClass, O2.firstRadius)/Lmin) * (0.5 * O2.endStationing - 0.5 * O2.startStationing + 0.6 * Lmin)}); 
                        }
                    }
                }


            }
            else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                // left lane
                let A1 = {stationing: O2.startStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                let A2 = {};
                let A3 = {};
                let A4 = {};

                // right lane
                let B1 = {stationing: O2.startStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                let B2 = {};
                let B3 = {};
                let B4 = {};

                if(O2.firstRadius > 0)
                {
                    A2 = {stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope}
                    A3 = {stationing: O2.startStationing + 0.4 * Lmin, crossSlope: e1}
                    A4 = {stationing: O2.endStationing, crossSlope: e1}

                    B2 = {stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope}
                    B3 = {stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -e1}
                    B4 = {stationing: O2.endStationing, crossSlope: -e1}
                }
                else if(O2.firstRadius < 0)
                {
                    A2 = {stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope}
                    A3 = {stationing: O2.startStationing + 0.4 * Lmin, crossSlope: -e1}
                    A4 = {stationing: O2.endStationing, crossSlope: -e1}

                    B2 = {stationing: O2.startStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope}
                    B3 = {stationing: O2.startStationing + 0.4 * Lmin, crossSlope: e1}
                    B4 = {stationing: O2.endStationing, crossSlope: e1}
                }

                if(L0 === Lmin)
                {
                    if(A4.stationing > A3.stationing) leftSide.push(A3, A4);
                    else if(A4.stationing <= A3.stationing) leftSide.push(A4);

                    if(B4.stationing > B3.stationing) rightSide.push(B3, B4);
                    else if(B4.stationing <= B3.stationing) rightSide.push(B4);
                }
                else if(L0 >= 0.6 * Lmin)
                {
                    if(A4.stationing > A3.stationing) leftSide.push(A2, A3, A4);
                    else if(A4.stationing <= A3.stationing && A4.stationing > A2.stationing) leftSide.push(A2, A4);
                    else if(A4.stationing <= A3.stationing && A4.stationing <= A2.stationing) leftSide.push(A4);

                    if(B4.stationing > B3.stationing) rightSide.push(B2, B3, B4);
                    else if(B4.stationing <= B3.stationing && B4.stationing > B2.stationing) rightSide.push(B2, B4);
                    else if(B4.stationing <= B3.stationing && B4.stationing <= B2.stationing) rightSide.push(B4);
                }
                else if(L0 < 0.6 * Lmin)
                {
                    if(A4.stationing > A3.stationing) leftSide.push(A3, A4);
                    else if(A4.stationing <= A3.stationing) leftSide.push(A4);

                    if(B4.stationing > B3.stationing) rightSide.push(B3, B4);
                    else if(B4.stationing <= B3.stationing) rightSide.push(B4);
                }
            }
            else if(O1.type === "Rettlinje" && O2.type === "Sirkelbue" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.firstRadius);

                let c1 = e1 / (e1 + e2);
                let c2 = e2 / (e1 + e2);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );
                
                let Lmin1 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );
                

                let Lmin2;
                if(Math.sign(O2.firstRadius) === Math.sign(O3.firstRadius))
                {
                    Lmin2 = calculateSuperelevationRunoffLength(
                            Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius)),
                            Math.abs(calculateCrossSlopeFromRadius(designClass, O3.firstRadius) - calculateCrossSlopeFromRadius(designClass, O2.firstRadius)),
                            wheelbase,
                            relativeVerticalSpeed
                        );
                }
                else if(Math.sign(O2.firstRadius) !== Math.sign(O3.firstRadius))
                {
                    Lmin2 = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, O3.firstRadius) + calculateCrossSlopeFromRadius(designClass, O2.firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
                }
                
                let A0 = {stationing: O2.startStationing - 0.6 * Lmin1 - L0, crossSlope: -normalCrossSlope};

                // Left lane
                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};
                
                // Right lane
                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};
            
                if(O2.firstRadius > 0 && O3.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: normalCrossSlope};
                    A2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: e1};
                    A3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: e1};
                    A4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: e2};

                    B1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: -normalCrossSlope};
                    B2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: -e1};
                    B3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: -e1};
                    B4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: -e2};                    
                }   
                else if(O2.firstRadius > 0 && O3.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: normalCrossSlope};
                    A2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: e1};
                    A3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: e1};
                    A4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: -e2};

                    B1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: -normalCrossSlope};
                    B2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: -e1};
                    B3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: -e1};
                    B4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: e2};
                }
                else if(O2.firstRadius < 0 && O3.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: -normalCrossSlope};
                    A2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: -e1};
                    A3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: -e1};
                    A4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: -e2};

                    B1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: normalCrossSlope};
                    B2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: e1};
                    B3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: e1};
                    B4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: e2};
                }
                else if(O2.firstRadius < 0 && O3.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: -normalCrossSlope};
                    A2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: -e1};
                    A3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: -e1};
                    A4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: e2};

                    B1 = {stationing: O2.startStationing - 0.6 * Lmin1 + L0, crossSlope: normalCrossSlope};
                    B2 = {stationing: O2.startStationing + 0.4 * Lmin1, crossSlope: e1};
                    B3 = {stationing: O2.endStationing - c1 * Lmin2, crossSlope: e1};
                    B4 = {stationing: O2.endStationing + c2 * Lmin2, crossSlope: -e2};
                }

                if(e1 === e2 && Lmin2 === 0)
                {
                    if(A2.stationing < A3.stationing)
                    {
                        if(L0 === Lmin1)
                        {
                            leftSide.push(A2, A3);
                            rightSide.push(B2, B3);
                        }
                        else if(L0 >= 0.6 * Lmin1)
                        {
                            leftSide.push(A1, A2, A3);
                            rightSide.push(B1, B2, B3);
                        }
                        else if(L0 < 0.6 * Lmin1)
                        {
                            leftSide.push(A2, A3);
                            rightSide.push(B2, B3);
                        }
                    }
                    else if(A2.stationing >= A3.stationing)
                    {
                        if(L0 === Lmin1)
                        {
                            leftSide.push(A3);
                            rightSide.push(B3);
                        }
                        else if(L0 >= 0.6 * Lmin1)
                        {
                            if(A1.stationing < A3.stationing)
                            {
                                leftSide.push(A1);
                                rightSide.push(B1);
                            }

                            leftSide.push(A3);
                            rightSide.push(B3);
                        }
                        else if(L0 < 0.6 * Lmin1)
                        {
                            leftSide.push(A3);
                            rightSide.push(B3);
                        }
                    }
                }
                else if(Lmin2 !== 0)
                {
                    if(A2.stationing < A3.stationing)
                    {
                        if(L0 === Lmin1)
                        {
                            leftSide.push(A2, A3);
                            rightSide.push(B2, B3);
                        }
                        else if(L0 >= 0.6 * Lmin1)
                        {
                            leftSide.push(A1, A2, A3);
                            rightSide.push(B1, B2, B3);
                        }
                        else if(L0 < 0.6 * Lmin1)
                        {
                            leftSide.push(A2, A3);
                            rightSide.push(B2, B3);
                        }
                    }
                    else if(A2.stationing >= A3.stationing)
                    {
                        if(L0 === Lmin1)
                        {
                            let crossProductA = (A2.stationing - A0.stationing) * (A4.crossSlope - A3.crossSlope) - (A2.crossSlope - A0.crossSlope) * (A4.stationing - A3.stationing);
                            let crossProductB = (B2.stationing - A0.stationing) * (B4.crossSlope - B3.crossSlope) - (B2.crossSlope - A0.crossSlope) * (B4.stationing - B3.stationing);

                            if(Math.abs(crossProductA) > 2e-8)
                            {   
                                let x = ((A0.stationing * (A2.crossSlope - A0.crossSlope)/(A2.stationing - A0.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A0.crossSlope + A3.crossSlope)/(((A2.crossSlope - A0.crossSlope)/(A2.stationing - A0.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                                if(x <= O2.endStationing && x >= O2.startStationing)
                                {
                                    let y = ((A2.crossSlope - A0.crossSlope)/(A2.stationing - A0.stationing)) * (x - A0.stationing) + A0.crossSlope;
                                    leftSide.push({stationing: x, crossSlope: y});
                                }

                            }

                            if(Math.abs(crossProductB) >= 2e-8)
                            {
                                let x = ((A0.stationing * (B2.crossSlope - A0.crossSlope)/(B2.stationing - A0.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - A0.crossSlope + B3.crossSlope)/(((B2.crossSlope - A0.crossSlope)/(B2.stationing - A0.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                                if(x <= O2.endStationing && x >= O2.startStationing)
                                {
                                    let y = ((B2.crossSlope - A0.crossSlope)/(B2.stationing - A0.stationing)) * (x - A0.stationing) + A0.crossSlope;
                                    rightSide.push({stationing: x, crossSlope: y});
                                }
                            }

                        }
                        else if(L0 >= 0.6 * Lmin1)
                        {
                            let crossProductA = (A2.stationing - A0.stationing) * (A4.crossSlope - A3.crossSlope) - (A2.crossSlope - A0.crossSlope) * (A4.stationing - A3.stationing);
                            let crossProductB = (B2.stationing - A0.stationing) * (B4.crossSlope - B3.crossSlope) - (B2.crossSlope - A0.crossSlope) * (B4.stationing - B3.stationing);

                            if(Math.abs(crossProductA) > 2e-8)
                            {
                                let x1 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A1.crossSlope + A3.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                                if(x1 > A1.stationing && x1 <= A2.stationing)
                                {
                                    let y = ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) * (x1 - A3.stationing) + A3.crossSlope;
                                    leftSide.push(A1, {stationing: x1, crossSlope: y});
                                }
                                else if(x1 >= O2.startStationing && x1 < A1.stationing)
                                {
                                    let crossSlopeA2 = (A1.stationing - A0.stationing) * (A4.crossSlope - A3.crossSlope) - (A1.crossSlope - A0.crossSlope) * (A4.stationing - A3.stationing);
                                    if(crossSlopeA2 > 2e-8)
                                    {
                                        let x2 = ((A0.stationing * (A1.crossSlope - A0.crossSlope)/(A1.stationing - A0.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A0.crossSlope + A3.crossSlope)/(((A1.crossSlope - A0.crossSlope)/(A1.stationing - A0.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                                        if(x2 >= O2.startStationing && x1 <= A1.stationing)
                                        {
                                            let y = ((A1.crossSlope - A0.crossSlope)/(A1.stationing - A0.stationing)) * (x2 - A0.stationing) + A0.crossSlope;
                                            leftSide.push({stationing: x1, crossSlope: y});
                                        }
                                    }
                                    
                                }
                            }

                            if(Math.abs(crossProductB) >= 2e-8)
                            {
                                let x1 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - B1.crossSlope + B3.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                                if(x1 > B1.stationing && x1 <= B2.stationing)
                                {
                                    let y = ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) * (x1 - B3.stationing) + B3.crossSlope;
                                    rightSide.push(A1, {stationing: x1, crossSlope: y});
                                }
                                else if(x1 >= O2.startStationing && x1 < B1.stationing)
                                {
                                    let crossSlopeB2 = (B1.stationing - A0.stationing) * (B4.crossSlope - B3.crossSlope) - (B1.crossSlope - A0.crossSlope) * (B4.stationing - B3.stationing);
                                    if(crossSlopeB2 > 2e-8)
                                    {
                                        let x2 = ((A0.stationing * (B1.crossSlope - A0.crossSlope)/(B1.stationing - A0.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - A0.crossSlope + B3.crossSlope)/(((B1.crossSlope - A0.crossSlope)/(B1.stationing - A0.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                                        if(x2 >= O2.startStationing && x1 <= B1.stationing)
                                        {
                                            let y = ((B1.crossSlope - A0.crossSlope)/(B1.stationing - A0.stationing)) * (x2 - A0.stationing) + A0.crossSlope;
                                            leftSide.push({stationing: x1, crossSlope: y});
                                        }
                                    }
                                }
                            }
                        }
                        else if(L0 < 0.6 * Lmin1)
                        {
                            let crossProductA = (A2.stationing - A0.stationing) * (A4.crossSlope - A3.crossSlope) - (A2.crossSlope - A0.crossSlope) * (A4.stationing - A3.stationing);
                            let crossProductB = (B2.stationing - A0.stationing) * (B4.crossSlope - B3.crossSlope) - (B2.crossSlope - A0.crossSlope) * (B4.stationing - B3.stationing);

                            if(Math.abs(crossProductA) > 2e-8)
                            {
                                let x1 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A1.crossSlope + A3.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                                if(x1 >= O2.startStationing && x1 <= A2.stationing)
                                {
                                    let y = ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) * (x1 - A3.stationing) + A3.crossSlope;
                                    leftSide.push({stationing: x1, crossSlope: y});
                                }
                            }

                            if(Math.abs(crossProductB) > 2e-8)
                            {
                                let x1 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - B1.crossSlope + B3.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                                if(x1 >= O2.startStationing && x1 <= B2.stationing)
                                {
                                    let y = ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) * (x1 - B3.stationing) + B3.crossSlope;
                                    rightSide.push({stationing: x1, crossSlope: y});
                                }
                            }
                        }
                    }
                }
            }
            
            //=====================================================================================

            if(O1.type === "Klotoide" && O2.type === "Rettlinje" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.secondRadius);

                let L01 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin1 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O1.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                let L02 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.secondRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                )

                let Lmin2 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.secondRadius),
                    calculateCrossSlopeFromRadius(designClass, O3.secondRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                // left lane
                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};
                let A5 = {};
                let A6 = {};

                // right lane
                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};
                let B5 = {};
                let B6 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O1.startStationing, crossSlope: e1};
                    B1 = {stationing: O1.startStationing, crossSlope: -e1};

                    if(O1.length >= L01 + Lmin1)
                    {
                        A2 = {stationing: O1.endStationing - L01, crossSlope: 0};
                        A3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O1.endStationing - L01, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};
                    }
                    else if(O1.length < L01 + Lmin1)
                    {
                        A2 = {stationing: O1.endStationing, crossSlope: 0};
                        A3 = {stationing: O2.startStationing + L01, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O1.endStationing + L01, crossSlope: -normalCrossSlope};
                    }
                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O1.startStationing, crossSlope: -e1};
                    B1 = {stationing: O1.startStationing, crossSlope: e1};

                    if(O1.length >= L01 + Lmin1)
                    {
                        A2 = {stationing: O1.endStationing - L01, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O1.endStationing - L01, crossSlope: 0};
                        B3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};
                    }
                    else if(O1.length < L01 + Lmin1)
                    {
                        A2 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.startStationing + L01, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O1.endStationing, crossSlope: 0};
                        B3 = {stationing: O1.endStationing + L01, crossSlope: -normalCrossSlope};
                    }
                }

                if(O3.secondRadius > 0)
                {
                    if(O3.length >= L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing + L02, crossSlope: 0};

                        B4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing + L02, crossSlope: -normalCrossSlope};
                    }
                    else if(O3.length < L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing, crossSlope: 0};

                        B4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                    }

                    A6 = {stationing: O3.endStationing, crossSlope: e1};
                    B6 = {stationing: O3.endStationing, crossSlope: -e1};
                    
                }
                else if(O3.secondRadius < 0)
                {
                    if(O3.length >= L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing + L02, crossSlope: -normalCrossSlope};

                        B4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing + L02, crossSlope: 0};
                    }
                    else if(O3.length < L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};

                        B4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing, crossSlope: 0};
                    }

                    A6 = {stationing: O3.endStationing, crossSlope: -e1};
                    B6 = {stationing: O3.endStationing, crossSlope: e1};
                }

                if(A3.stationing < A4.stationing)
                {
                    if(O1.length >= L01 + Lmin1)
                    {
                        leftSide.push(A3);
                        rightSide.push(B3);
                    }
                    else if(O1.length < L01 + Lmin1)
                    {
                        leftSide.push(A2, A3);
                        rightSide.push(B2, B3);
                    }

                    if(O3.length >= L02 + Lmin2)
                    {
                        leftSide.push(A4);
                        rightSide.push(B4);
                    }
                    else if(O3.length < L02 + Lmin2)
                    {
                        leftSide.push(A4, A5);
                        rightSide.push(B4, B5);
                    }
                }
                else if(A3.stationing >= A4.stationing)
                {
                    let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                    let crossProductB = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);

                    if(crossProductA > 2e-8)
                    {
                        let x = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                        if(x > O2.startStationing && x < O2.endStationing)
                        {
                            let y = ((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) * (x - A2.stationing) + A2.crossSlope;
                            leftSide.push(A2, {stationing: x, crossSlope: y}, A5);
                        }
                        else
                        {
                            leftSide.push(A2, A5);
                        }
                    }
                    else
                    {
                        leftSide.push(A2, A5);
                    }

                    if(crossProductB > 2e-8)
                    {
                        let x = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                        if(x > O2.startStationing && x < O2.endStationing)
                        {
                            let y = ((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) * (x - B2.stationing) + B2.crossSlope;
                            rightSide.push(B2, {stationing: x, crossSlope: y}, B5);
                        }
                        else
                        {
                            rightSide.push(B2, B5);
                        }
                    }
                    else
                    {
                        rightSide.push(B2, B5);

                    }
                }

            }
            else if(O1.type === "Klotoide" && O2.type === "Rettlinje" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.firstRadius);

                let L01 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin1 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O1.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                let L02 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                )

                let Lmin2 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O3.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                // left lane
                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};
                let A5 = {};
                let A6 = {};

                // right lane
                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};
                let B5 = {};
                let B6 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O1.startStationing, crossSlope: e1};
                    B1 = {stationing: O1.startStationing, crossSlope: -e1};

                    if(O1.length >= L01 + Lmin1)
                    {
                        A2 = {stationing: O1.endStationing - L01, crossSlope: 0};
                        A3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope}

                        B2 = {stationing: O1.endStationing - L01, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope}
                    }
                    else
                    {
                        A2 = {stationing: O1.endStationing, crossSlope: 0};
                        A3 = {stationing: O2.startStationing + L01, crossSlope: -normalCrossSlope}

                        B2 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.startStationing + L01, crossSlope: -normalCrossSlope}
                    }
                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O1.startStationing, crossSlope: -e1};
                    B1 = {stationing: O1.startStationing, crossSlope: e1};

                    if(O1.length >= L01 + Lmin1)
                    {
                        A2 = {stationing: O1.endStationing - L01, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope}

                        B2 = {stationing: O1.endStationing - L01, crossSlope: 0};
                        B3 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope}
                    }
                    else
                    {
                        A2 = {stationing: O1.endStationing, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.startStationing + L01, crossSlope: -normalCrossSlope}

                        B2 = {stationing: O1.endStationing, crossSlope: 0};
                        B3 = {stationing: O2.startStationing + L01, crossSlope: -normalCrossSlope}
                    }
                }

                if(O3.firstRadius > 0)
                {
                    A4 = {stationing: O2.endStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    A5 = {stationing: O2.endStationing - 0.6 * Lmin2 + L02, crossSlope: normalCrossSlope};
                    A6 = {stationing: O2.endStationing + 0.4 * Lmin2, crossSlope: e1};

                    B4 = {stationing: O2.endStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    B5 = {stationing: O2.endStationing - 0.6 * Lmin2 + L02, crossSlope: -normalCrossSlope};
                    B6 = {stationing: O2.endStationing + 0.4 * Lmin2, crossSlope: -e1};
                }
                else if(O3.firstRadius < 0)
                {
                    A4 = {stationing: O2.endStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    A5 = {stationing: O2.endStationing - 0.6 * Lmin2 + L02, crossSlope: -normalCrossSlope};
                    A6 = {stationing: O2.endStationing + 0.4 * Lmin2, crossSlope: -e1};

                    B4 = {stationing: O2.endStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    B5 = {stationing: O2.endStationing - 0.6 * Lmin2 + L02, crossSlope: normalCrossSlope};
                    B6 = {stationing: O2.endStationing + 0.4 * Lmin2, crossSlope: e1};
                }

                if(A3.stationing < A4.stationing)
                {
                    if(O1.length >= L01 + Lmin1) leftSide.push(A3);
                    else if(O1.length < L01 + Lmin1) leftSide.push(A2, A3);
                    
                    if(A5.stationing <= O2.endStationing) leftSide.push(A4, A5);
                    else if(A5.stationing > O2.endStationing) leftSide.push(A4);
                }
                else if(A3.stationing >= A4.stationing)
                {
                    if(O1.length >= L01 + Lmin1)
                    {
                        if(A4.stationing <= A3.stationing && A3.stationing < A5.stationing)
                        {
                            if(A5.stationing <= O2.endStationing) leftSide.push(A3, A5);
                            else if(A5.stationing > O2.endStationing) leftSide.push(A3);
                        }
                        if(A3.stationing >= A5.stationing) leftSide.push(A3);
                    }
                    else if(O1.length < L01 + Lmin1)
                    {
                        let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                        if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                            if(A5.stationing <= O2.endStationing)
                            {
                                if(x > O2.startStationing && x < A5.stationing)
                                {
                                    let y = ((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) * (x- A2.stationing) + A2.crossSlope;
                                    leftSide.push(A2, {stationing: x, crossSlope: y}, A5);
                                }
                                else if(x >= A5.stationing && x < O2.endStationing)
                                {
                                    let x1 = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A5.stationing * (A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) - A2.crossSlope + A5.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)));
                                    if(x1 >= A5.stationing && x1 < O2.endStationing)
                                    {
                                        let y = ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) * (x1- A5.stationing) + A5.crossSlope;
                                        leftSide.push(A2, {stationing: x1, crossSlope: y});
                                    }
                                }
                                else
                                {
                                    leftSide.push(A2, A5);
                                }
                            }
                            else if(A5.stationing > O2.endStationing)
                            {
                                if(O2.startElevation < x && O2.endStationing >= x)
                                {
                                    let y = ((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) * (x- A2.stationing) + A2.crossSlope;
                                    leftSide.push(A2, {stationing: x, crossSlope: y});
                                }
                                else leftSide.push(A2);
                                
                            }
                        }
                        else if(Math.abs(crossProductA) <= 2e-8)
                        {
                            if(A5.stationing <= O2.endStationing)
                            {
                                if(A5.stationing > O2.startStationing) leftSide.push(A2, A5);
                                else if(A5.stationing <= O2.endStationing) leftSide.push(A2);
                            }
                            else if(A5.stationing > O2.endStationing) leftSide.push(A2);
                        }
                    }
                }

                if(B3.stationing < B4.stationing)
                {
                    if(O1.length >= L01 + Lmin1) rightSide.push(B3);
                    else if(O1.length < L01 + Lmin1) rightSide.push(B2, B3);
                    
                    if(B5.stationing <= O2.endStationing) rightSide.push(B4, B5);
                    else if(B5.stationing > O2.endStationing) rightSide.push(B4);
                }
                else if(B3.stationing >= B4.stationing)
                {
                    if(O1.length >= L01 + Lmin1)
                    {
                        if(B4.stationing <= B3.stationing && B3.stationing < B5.stationing)
                        {
                            if(B5.stationing <= O2.endStationing) rightSide.push(B3, B5);
                            else if(B5.stationing > O2.endStationing) rightSide.push(B3);
                        }
                        if(B3.stationing >= B5.stationing) rightSide.push(B3);
                    }
                    else if(O1.length < L01 + Lmin1)
                    {
                        let crossProductB = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);
                        if(Math.abs(crossProductB) > 2e-8)
                        {
                            let x = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                            if(B5.stationing <= O2.endStationing)
                            {
                                if(x > O2.startStationing && x < B5.stationing)
                                {
                                    let y = ((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) * (x- B2.stationing) + B2.crossSlope;
                                    rightSide.push(B2, {stationing: x, crossSlope: y}, B5);
                                }
                                else if(x >= B5.stationing && x < O2.endStationing)
                                {
                                    let x1 = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B5.stationing * (B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) - B2.crossSlope + B5.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)));
                                    if(x1 >= B5.stationing && x1 < O2.endStationing)
                                    {
                                        let y = ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) * (x1- B5.stationing) + B5.crossSlope;
                                        rightSide.push(B2, {stationing: x1, crossSlope: y});
                                    }
                                }
                                else
                                {
                                    rightSide.push(B2, B5);
                                }
                            }
                            else if(A5.stationing > O2.endStationing)
                            {
                                if(O2.startElevation < x && O2.endStationing >= x)
                                {
                                    let y = ((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) * (x- B2.stationing) + B2.crossSlope;
                                    rightSide.push(B2, {stationing: x, crossSlope: y});
                                }
                                else rightSide.push(B2);
                                
                            }
                        }
                        else if(Math.abs(crossProductB) <= 2e-8)
                        {
                            if(B5.stationing <= O2.endStationing)
                            {
                                if(B5.stationing > O2.startStationing) rightSide.push(B2, B5);
                                else if(B5.stationing <= O2.endStationing) rightSide.push(B2);
                            }
                            else if(B5.stationing > O2.endStationing) rightSide.push(B2);
                        }
                    }
                }

            }
            else if(O1.type === "Klotoide" && O2.type === "Klotoide" && O3.type === "Rettlinje")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );
                

                let A1 = {};
                let A2 = {};
                let A3 = {};

                let B1 = {};
                let B2 = {};
                let B3 = {};

                if(O2.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    B1 = {stationing: O2.startStationing, crossSlope: -e1};

                    if(O2.length >= L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing - L0, crossSlope: 0};
                        A3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing - L0, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                    }
                    else if(O2.length < L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing, crossSlope: 0};
                        A3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};
                    }
                }
                else if(O2.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B1 = {stationing: O2.startStationing, crossSlope: e1};

                    if(O2.length >= L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing - L0, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing - L0, crossSlope: 0};
                        B3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                    }
                    else if(O2.length < L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing, crossSlope: 0};
                        B3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};
                    }
                }

                if(O2.length >= L0 + Lmin)
                {
                    leftSide.push(A1, A2, A3);
                    rightSide.push(B1, B2, B3);
                }
                else if(O2.length < L0 + Lmin)
                {
                    leftSide.push(A1, A2);
                    rightSide.push(B1, B2);
                }
            }
            else if(O1.type === "Klotoide" && O2.type === "Klotoide" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O2.secondRadius);

                let A1 = {};
                let A2 = {};
                let B1 = {};
                let B2 = {};

                if(O2.firstRadius > 0 && O2.secondRadius === 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: 0};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: 0};
                    
                }
                else if(O2.firstRadius < 0 && O2.secondRadius === 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: 0};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: 0};
                }
                else if(O2.firstRadius === 0 && O2.secondRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: 0};
                    A2 = {stationing: O2.endStationing, crossSlope: e1};

                    B1 = {stationing: O2.startStationing, crossSlope: 0};
                    B2 = {stationing: O2.endStationing, crossSlope: -e1};
                }
                else if(O2.firstRadius === 0 && O2.secondRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: 0};
                    A2 = {stationing: O2.endStationing, crossSlope: -e1};

                    B1 = {stationing: O2.startStationing, crossSlope: 0};
                    B2 = {stationing: O2.endStationing, crossSlope: e1};
                }
                if(O2.firstRadius > 0 && O2.secondRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: e2};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: -e2};
                }
                if(O2.firstRadius < 0 && O2.secondRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: -e2};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: e2};
                }

                leftSide.push(A1, A2);
                rightSide.push(B1, B2);

            }
            else if(O1.type === "Klotoide" && O2.type === "Klotoide" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O2.secondRadius);

                let A1 = {};
                let A2 = {};
                
                let B1 = {};
                let B2 = {};

                if(O2.firstRadius === 0 && O2.secondRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: 0};
                    A2 = {stationing: O2.endStationing, crossSlope: e1};

                    B1 = {stationing: O2.startStationing, crossSlope: 0};
                    B2 = {stationing: O2.endStationing, crossSlope: -e1};
                }
                else if(O2.firstRadius === 0 && O2.secondRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: 0};
                    A2 = {stationing: O2.endStationing, crossSlope: -e1};

                    B1 = {stationing: O2.startStationing, crossSlope: 0};
                    B2 = {stationing: O2.endStationing, crossSlope: e1};
                }
                if(O2.firstRadius > 0 && O2.secondRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: e2};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: -e2};
                }
                if(O2.firstRadius < 0 && O2.secondRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: -e2};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: e2};
                }

                leftSide.push(A1, A2);
                rightSide.push(B1, B2);
            }
            else if(O1.type === "Klotoide" && O2.type === "Sirkelbue" && O3.type === "Rettlinje")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                // left lane
                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {stationing: O2.endStationing + 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};

                // right lane
                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {stationing: O2.endStationing + 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};

                if(O2.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing - 0.4 * Lmin, crossSlope: e1};
                    A3 = {stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -e1};
                    B3 = {stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                }
                else if(O2.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing - 0.4 * Lmin, crossSlope: -e1};
                    A3 = {stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing - 0.4 * Lmin, crossSlope: e1};
                    B3 = {stationing: O2.endStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope};
                }
                if(L0 === Lmin)
                {
                    if(A1.stationing < A2.stationing) leftSide.push(A1, A2);
                    else if(A1.stationing >= A2.stationing) leftSide.push(A1);

                    if(B1.stationing < B2.stationing) rightSide.push(B1, B2);
                    else if(B1.stationing >= B2.stationing) rightSide.push(B1);
                }
                else if(L0 >= 0.6 * Lmin)
                {
                    if(A1.stationing < A2.stationing) leftSide.push(A1, A2, A3);
                    else if(A1.stationing >= A2.stationing && A1.stationing < A3.stationing) leftSide.push(A1, A3);
                    else if(A1.stationing >= A2.stationing && A1.stationing >= A3.stationing) leftSide.push(A1);

                    if(B1.stationing < B2.stationing) rightSide.push(B1, B2, B3);
                    else if(B1.stationing >= B2.stationing && B1.stationing < B3.stationing) rightSide.push(B1, B3);
                    else if(B1.stationing >= B2.stationing && B1.stationing >= B3.stationing) rightSide.push(B1);
                }
                else if(L0 < 0.6 * Lmin)
                {
                    if(A1.stationing < A2.stationing) leftSide.push(A1, A2);
                    else if(A1.stationing >= A2.stationing) leftSide.push(A1);
                    
                    if(B1.stationing < B2.stationing) rightSide.push(B1, B2);
                    else if(B1.stationing >= B2.stationing) rightSide.push(B1);
                }
            }
            else if(O1.type === "Klotoide" && O2.type === "Sirkelbue" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let A1 = {};
                let A2 = {};
                
                let B1 = {};
                let B2 = {};

                if(O2.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: e1};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: -e1};
                }
                else if(O2.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: -e1};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: e1};
                }

                leftSide.push(A1, A2);
                rightSide.push(B1, B2);
            }
            else if(O1.type === "Klotoide" && O2.type === "Sirkelbue" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let A1 = {};
                let A2 = {};
                
                let B1 = {};
                let B2 = {};

                if(O2.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: e1};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: -e1};
                }
                else if(O2.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: -e1};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: e1};
                }

                leftSide.push(A1, A2);
                rightSide.push(B1, B2);
            }

            //=====================================================================================

            if(O1.type === "Sirkelbue" && O2.type === "Rettlinje" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.secondRadius);

                let L01 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin1 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O1.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                let L02 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.secondRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                )

                let Lmin2 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.secondRadius),
                    calculateCrossSlopeFromRadius(designClass, O3.secondRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                // left lane
                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};
                let A5 = {};
                let A6 = {};

                // right lane
                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};
                let B5 = {};
                let B6 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing - 0.4 * Lmin1, crossSlope: e1};
                    A2 = {stationing: O2.startStationing + 0.6 * Lmin1 - L01, crossSlope: normalCrossSlope};
                    A3 = {stationing: O2.startStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};

                    B1 = {stationing: O2.startStationing - 0.4 * Lmin1, crossSlope: -e1};
                    B2 = {stationing: O2.startStationing + 0.6 * Lmin1 - L01, crossSlope: -normalCrossSlope};
                    B3 = {stationing: O2.startStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};
                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing - 0.4 * Lmin1, crossSlope: -e1};
                    A2 = {stationing: O2.startStationing + 0.6 * Lmin1 - L01, crossSlope: -normalCrossSlope};
                    A3 = {stationing: O2.startStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};

                    B1 = {stationing: O2.startStationing - 0.4 * Lmin1, crossSlope: e1};
                    B2 = {stationing: O2.startStationing + 0.6 * Lmin1 - L01, crossSlope: normalCrossSlope};
                    B3 = {stationing: O2.startStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};
                }

                if(O3.secondRadius > 0)
                {

                    if(O3.length >= L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing + L02, crossSlope: 0};
                        A6 = {stationing: O3.endStationing, crossSlope: e1};

                        B4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing + L02, crossSlope: -normalCrossSlope};
                        B6 = {stationing: O3.endStationing, crossSlope: -e1};
                    }
                    else if(O3.length < L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing, crossSlope: 0};
                        A6 = {stationing: O3.endStationing, crossSlope: e1};

                        B4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B6 = {stationing: O3.endStationing, crossSlope: -e1};
                    }
                }
                else if(O3.secondRadius < 0)
                {
                    if(O3.length >= L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing + L02, crossSlope: -normalCrossSlope};
                        A6 = {stationing: O3.endStationing, crossSlope: -e1};

                        B4 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing + L02, crossSlope: 0};
                        B6 = {stationing: O3.endStationing, crossSlope: e1};
                    }
                    else if(O3.length < L02 + Lmin2)
                    {
                        A4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        A5 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A6 = {stationing: O3.endStationing, crossSlope: -e1};

                        B4 = {stationing: O2.endStationing - L02, crossSlope: -normalCrossSlope};
                        B5 = {stationing: O2.endStationing, crossSlope: 0};
                        B6 = {stationing: O3.endStationing, crossSlope: e1};
                    }
                }
                
                if(A3.stationing < A4.stationing)
                {
                    if(A2.stationing >= O2.startStationing) leftSide.push(A2, A3);
                    else if(A2.stationing < O2.startStationing) leftSide.push(A3);

                    if(O3.length >= L02 + Lmin2) leftSide.push(A4);
                    else if(O3.length < L02 + Lmin2) leftSide.push(A4, A5);
                }
                else if(A3.stationing >= A4.stationing)
                {
                    if(O3.length >= L02 + Lmin2)
                    {
                        if(A2.stationing < A4.stationing)
                        {
                            if(A2.stationing >= O2.startStationing) leftSide.push(A2, A4);
                            else if(A2.stationing < O2.startStationing) leftSide.push(A4);
                        }
                        else if(A2.stationing >= A4.stationing && A3.stationing >= A4.stationing) leftSide.push(A4);
                    }
                    else if(O3.length < L02 + Lmin2)
                    {   
                        let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                        
                        if(Math.abs(crossProductA) > 2e-8)
                        {

                            let x1 = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                            
                            if(A2.stationing >= O2.startStationing)
                            {
                                let y1 = ((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) * (x1- A2.stationing) + A2.crossSlope;
                                if(A2.stationing < x1 && x1 <= O2.endStationing) leftSide.push(A2, {stationing: x1, crossSlope: y1}, A5);
                                else if(O2.startStationing <= x1 && x1 < A2.stationing)
                                {
                                    let crossSlopeA2 =  (A2.stationing - A1.stationing) * (A5.crossSlope - A4.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A5.stationing - A4.stationing);
                                    if(crossSlopeA2 > 2e-8)
                                    {
                                        let x2 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A1.crossSlope + A4.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                                        if(O2.startStationing <= x2 && x2 < A2.stationing)
                                        {
                                            let y2 = ((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) * (x2- A1.stationing) + A1.crossSlope; 
                                            leftSide.push({stationing: x2, crossSlope: y2}, A2);
                                        }
                                        else leftSide.push(A5);
                                    }
                                    else leftSide.push(A5);
                                    
                                }
                                else
                                {
                                    if(A2.stationing >= A5.stationing) leftSide.push(A5);
                                    else leftSide.push(A2, A5);
                                }
                            }
                            else if(A2.stationing < O2.startStationing)
                            {
                                if(O2.startStationing <= x1 && x1 < O2.endStationing)
                                {
                                    let y1 = ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) * (x1- A4.stationing) + A4.crossSlope;
                                    leftSide.push({stationing: x1, crossSlope: y1}, A5);   
                                }
                                else leftSide.push(A5);
                            }
                        }
                        if(Math.abs(crossProductA) <= 2e-8)
                        {
                            if(A2.stationing >= O2.startStationing)
                            {
                                if(A2.stationing < O2.endStationing) leftSide.push(A2, A5);
                                else if(A2.stationing >= O2.endStationing) leftSide.push(A5);
                            }
                            else if (A2.stationing < O2.startStationing) leftSide.push(A5);
                        }
                    }
                }


                if(B3.stationing < B4.stationing)
                {
                    if(B2.stationing >= O2.startStationing) rightSide.push(B2, B3);
                    else if(B2.stationing < O2.startStationing) rightSide.push(B3);

                    if(O3.length >= L02 + Lmin2) rightSide.push(B4);
                    else if(O3.length < L02 + Lmin2) rightSide.push(B4, B5);
                }
                else if(B3.stationing >= B4.stationing)
                {
                    if(O3.length >= L02 + Lmin2)
                    {
                        if(B2.stationing < B4.stationing)
                        {
                            if(B2.stationing >= O2.startStationing) rightSide.push(B2, B4);
                            else if(B2.stationing < O2.startStationing) rightSide.push(B4);
                        }
                        else if(B2.stationing >= B4.stationing && B3.stationing >= B4.stationing) rightSide.push(B4);
                    }
                    else if(O3.length < L02 + Lmin2)
                    {   
                        let crossProductB = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);
                        
                        if(Math.abs(crossProductB) > 2e-8)
                        {
                            let x1 = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                            
                            if(B2.stationing >= O2.startStationing)
                            {
                                let y1 = ((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) * (x1- B2.stationing) + B2.crossSlope;
                                if(B2.stationing < x1 && x1 <= O2.endStationing) rightSide.push(B2, {stationing: x1, crossSlope: y1}, B5);
                                else if(O2.startStationing <= x1 && x1 < B2.stationing)
                                {
                                    let crossSlopeB2 =  (B2.stationing - B1.stationing) * (B5.crossSlope - B4.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B5.stationing - B4.stationing);
                                    if(crossSlopeB2 > 2e-8)
                                    {
                                        let x2 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B1.crossSlope + B4.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                                        if(O2.startStationing <= x2 && x2 < B2.stationing)
                                        {
                                            let y2 = ((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) * (x2- B1.stationing) + B1.crossSlope; 
                                            rightSide.push({stationing: x2, crossSlope: y2}, B2);
                                        }
                                        else rightSide.push(B5);
                                    }
                                    
                                    
                                }
                                else
                                {
                                    if(B2.stationing >= B5.stationing) rightSide.push(B5);
                                    else rightSide.push(B2, B5);
                                }
                            }
                            else if(B2.stationing < O2.startStationing)
                            {
                                if(O2.startStationing <= x1 && x1 < O2.endStationing)
                                {
                                    let y1 = ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) * (x1- B4.stationing) + B4.crossSlope;
                                    rightSide.push({stationing: x1, crossSlope: y1}, B5);   
                                }
                                else rightSide.push(B5);
                            }
                        }
                        if(Math.abs(crossProductB) <= 2e-8)
                        {
                            if(B2.stationing >= O2.startStationing)
                            {
                                if(B2.stationing < O2.endStationing) rightSide.push(B2, B5);
                                else if(B2.stationing >= O2.endStationing) rightSide.push(B5);
                            }
                            else if (B2.stationing < O2.startStationing) rightSide.push(B5);
                        }
                    }
                }
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Rettlinje" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.firstRadius);

                let L01 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin1 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O1.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                let L02 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                )

                let Lmin2 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O3.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                // left lane
                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};
                let A5 = {};
                let A6 = {};

                // right lane
                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};
                let B5 = {};
                let B6 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O1.endStationing - 0.4 * Lmin1, crossSlope: e1};
                    A2 = {stationing: O1.endStationing + 0.6 * Lmin1 - L01, crossSlope: normalCrossSlope};
                    A3 = {stationing: O1.endStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};

                    B1 = {stationing: O1.endStationing - 0.4 * Lmin1, crossSlope: -e1};
                    B2 = {stationing: O1.endStationing + 0.6 * Lmin1 - L01, crossSlope: -normalCrossSlope};
                    B3 = {stationing: O1.endStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};

                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O1.endStationing - 0.4 * Lmin1, crossSlope: -e1};
                    A2 = {stationing: O1.endStationing + 0.6 * Lmin1 - L01, crossSlope: -normalCrossSlope};
                    A3 = {stationing: O1.endStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};

                    B1 = {stationing: O1.endStationing - 0.4 * Lmin1, crossSlope: e1};
                    B2 = {stationing: O1.endStationing + 0.6 * Lmin1 - L01, crossSlope: normalCrossSlope};
                    B3 = {stationing: O1.endStationing + 0.6 * Lmin1 + L01, crossSlope: -normalCrossSlope};
                }

                if(O3.firstRadius > 0)
                {
                    A4 = {stationing: O3.startStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    A5 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: normalCrossSlope};
                    A6 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: e2};

                    B4 = {stationing: O3.startStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    B5 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: -normalCrossSlope};
                    B6 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: -e2};
                }
                else if(O3.firstRadius < 0)
                {
                    A4 = {stationing: O3.startStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    A5 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: -normalCrossSlope};
                    A6 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: -e2};

                    B4 = {stationing: O3.startStationing - 0.6 * Lmin2 - L02, crossSlope: -normalCrossSlope};
                    B5 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: normalCrossSlope};
                    B6 = {stationing: O3.startStationing - 0.6 * Lmin2 + L02, crossSlope: e2};
                }
                
                if(A3.stationing < A4.stationing)
                {
                    if(A2.stationing >= O2.startStationing) leftSide.push(A2, A3);
                    else if(A2.stationing < O2.startStationing) leftSide.push(A3);

                    if(A5.stationing <= O2.endStationing) leftSide.push(A4, A5);
                    else if(A5.stationing > O2.endStationing) leftSide.push(A4);
                }
                else if(A3.stationing >= A4.stationing)
                {
                    if(A2.stationing < O2.startStationing && A5.stationing > O2.endStationing && A2.stationing < A5.stationing)
                    {
                        let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                        if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                            if(x >= O2.startStationing && x <= O2.endStationing)
                            {
                                let y = ((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) * (x- A2.stationing) + A2.crossSlope;
                                leftSide.push({stationing: x, crossSlope: y});
                            }
                        }
                    }
                    else if(A2.stationing >= O2.startStationing && A5.stationing > O2.endStationing && A2.stationing < A5.stationing)
                    {
                        let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                        if(Math.abs(crossProductA) <= 2e-8) leftSide.push(A2);
                        else if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                        
                            if(x > A2.stationing && x <= O2.endStationing)
                            {
                                let y = ((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) * (x- A2.stationing) + A2.crossSlope; 
                                leftSide.push(A2, {stationing: x, crossSlope: y});
                            }
                            else if(x >= O2.startStationing && x <= A2.stationing)
                            {
                                let x2 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A1.crossSlope + A4.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                                if(x2 >= O2.startStationing && x2 <= A2.stationing)
                                {
                                    let y2 = ((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) * (x2- A1.stationing) + A1.crossSlope; 
                                    leftSide.push({stationing: x2, crossSlope: y2});
                                }
                                
                            }
                        }
                    }
                    else if(A2.stationing < O2.startStationing && A5.stationing <= O2.endStationing && A2.stationing < A5.stationing)
                    {
                        let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                        if(Math.abs(crossProductA) <= 2e-8) leftSide.push(A5);
                        else if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));

                            if(x >= O2.startStationing && x < A5.stationing)
                            {
                                let y = ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) * (x- A4.stationing) + A4.crossSlope; 
                                leftSide.push({stationing: x, crossSlope: y}, A5);
                            }
                            else if(x >= A5.stationing && x <= O2.endStationing)
                            {
                                let x2 = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A5.stationing * (A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)));
                                if(x2 >= O2.startStationing && x2 <= A2.stationing)
                                {
                                    let y2 = ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) * (x2- A5.stationing) + A5.crossSlope; 
                                    leftSide.push({stationing: x2, crossSlope: y2});
                                }
                            }
                        }
                    }
                    else if(A2.stationing >= O2.startStationing && A5.stationing <= O2.endStationing && A2.stationing < A5.stationing)
                    {
                        let crossProductA = (A3.stationing - A2.stationing) * (A5.crossSlope - A4.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A5.stationing - A4.stationing);
                        if(Math.abs(crossProductA) <= 2e-8) leftSide.push(A2, A5);
                        else if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                            
                            if(x > A2.stationing && x < A5.stationing)
                            {
                                let y = ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) * (x - A4.stationing) + A4.crossSlope; 
                                leftSide.push(A2, {stationing: x, crossSlope: y}, A5);
                            }
                            else if(x >= O2.startStationing && x <= A2.stationing)
                            {
                                let crossProductA1 = (A2.stationing - A1.stationing) * (A5.crossSlope - A4.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A5.stationing - A4.stationing);
                                if(Math.abs(crossProductA1) > 2e-8)
                                {
                                    let x1 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A1.crossSlope + A4.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                                    if(x1 >= O2.startStationing && x1 <= A2.stationing)
                                    {
                                        let y1 = ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) * (x1 - A4.stationing) + A4.crossSlope; 
                                        leftSide.push({stationing: x1, crossSlope: y1}, A5);
                                    }
                                }
                            }
                            else if(x >= A5.stationing && x <= O2.endStationing)
                            {
                                let crossProductA2 = (A3.stationing - A2.stationing) * (A6.crossSlope - A5.crossSlope) - (A3.crossSlope - A2.crossSlope) * (A6.stationing - A6.stationing);
                                if(Math.abs(crossProductA2) > 2e-8)
                                {
                                    let x2 = ((A2.stationing * (A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - (A5.stationing * (A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) - A2.crossSlope + A4.crossSlope)/(((A3.crossSlope - A2.crossSlope)/(A3.stationing - A2.stationing)) - ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)));
                                    if(x2 >= A5.stationing && x2 <= O2.endStationing)
                                    {
                                        let y2 = ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) * (x2 - A5.stationing) + A5.crossSlope; 
                                        leftSide.push(A2, {stationing: x2, crossSlope: y2});
                                    }
                                }
                            }
                        }
                    }
                    else if(A2.stationing >= A5.stationing)
                    {
                        let crossProductA3 = (A2.stationing - A1.stationing) * (A6.crossSlope - A5.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A6.stationing - A6.stationing);
                        if(Math.abs(crossProductA3) > 2e-8)
                        {
                            let x3 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A5.stationing * (A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) - A1.crossSlope + A4.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)));
                            if(x3 >= O2.startStationing && x3 <= O2.endStationing)
                            {
                                let y3 = ((A6.crossSlope - A5.crossSlope)/(A6.stationing - A5.stationing)) * (x3 - A5.stationing) + A5.crossSlope; 
                                leftSide.push({stationing: x3, crossSlope: y3});
                            }
                        }
                    }
                }

                if(B3.stationing < B4.stationing)
                {
                    if(B2.stationing >= O2.startStationing) rightSide.push(B2, B3);
                    else if(B2.stationing < O2.startStationing) rightSide.push(B3);

                    if(B5.stationing <= O2.endStationing) rightSide.push(B4, B5);
                    else if(B5.stationing > O2.endStationing) rightSide.push(B4);
                }
                else if(B3.stationing >= B4.stationing)
                {
                    if(B2.stationing < O2.startStationing && B5.stationing > O2.endStationing && B2.stationing < B5.stationing)
                    {
                        let crossProductA = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);
                        if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                            if(x >= O2.startStationing && x <= O2.endStationing)
                            {
                                let y = ((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) * (x- B2.stationing) + B2.crossSlope;
                                rightSide.push({stationing: x, crossSlope: y});
                            }
                        }
                    }
                    else if(B2.stationing >= O2.startStationing && B5.stationing > O2.endStationing && B2.stationing < B5.stationing)
                    {
                        let crossProductA = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);
                        if(Math.abs(crossProductA) <= 2e-8) rightSide.push(B2);
                        else if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                        
                            if(x > B2.stationing && x <= O2.endStationing)
                            {
                                let y = ((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) * (x- B2.stationing) + B2.crossSlope; 
                                rightSide.push(B2, {stationing: x, crossSlope: y});
                            }
                            else if(x >= O2.startStationing && x <= B2.stationing)
                            {
                                let x2 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B1.crossSlope + B4.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                                if(x2 >= O2.startStationing && x2 <= B2.stationing)
                                {
                                    let y2 = ((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) * (x2- B1.stationing) + B1.crossSlope; 
                                    rightSide.push({stationing: x2, crossSlope: y2});
                                }
                                
                            }
                        }
                    }
                    else if(B2.stationing < O2.startStationing && B5.stationing <= O2.endStationing && B2.stationing < B5.stationing)
                    {
                        let crossProductA = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);
                        if(Math.abs(crossProductA) <= 2e-8) rightSide.push(B5);
                        else if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));

                            if(x >= O2.startStationing && x < B5.stationing)
                            {
                                let y = ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) * (x- B4.stationing) + B4.crossSlope; 
                                rightSide.push({stationing: x, crossSlope: y}, B5);
                            }
                            else if(x >= B5.stationing && x <= O2.endStationing)
                            {
                                let x2 = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B5.stationing * (B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)));
                                if(x2 >= O2.startStationing && x2 <= B2.stationing)
                                {
                                    let y2 = ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) * (x2- B5.stationing) + B5.crossSlope; 
                                    rightSide.push({stationing: x2, crossSlope: y2});
                                }
                            }
                        }
                    }
                    else if(B2.stationing >= O2.startStationing && B5.stationing <= O2.endStationing && B2.stationing < B5.stationing)
                    {
                        let crossProductA = (B3.stationing - B2.stationing) * (B5.crossSlope - B4.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B5.stationing - B4.stationing);
                        if(Math.abs(crossProductA) <= 2e-8) rightSide.push(B2, B5);
                        else if(Math.abs(crossProductA) > 2e-8)
                        {
                            let x = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                            
                            if(x > B2.stationing && x < B5.stationing)
                            {
                                let y = ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) * (x - B4.stationing) + B4.crossSlope; 
                                rightSide.push(B2, {stationing: x, crossSlope: y}, B5);
                            }
                            else if(x >= O2.startStationing && x <= B2.stationing)
                            {
                                let crossProductA1 = (B2.stationing - B1.stationing) * (B5.crossSlope - B4.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B5.stationing - B4.stationing);
                                if(Math.abs(crossProductA1) > 2e-8)
                                {
                                    let x1 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B1.crossSlope + B4.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                                    if(x1 >= O2.startStationing && x1 <= B2.stationing)
                                    {
                                        let y1 = ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) * (x1 - B4.stationing) + B4.crossSlope; 
                                        rightSide.push({stationing: x1, crossSlope: y1}, B5);
                                    }
                                }
                            }
                            else if(x >= B5.stationing && x <= O2.endStationing)
                            {
                                let crossProductA2 = (B3.stationing - B2.stationing) * (B6.crossSlope - B5.crossSlope) - (B3.crossSlope - B2.crossSlope) * (B6.stationing - B6.stationing);
                                if(Math.abs(crossProductA2) > 2e-8)
                                {
                                    let x2 = ((B2.stationing * (B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - (B5.stationing * (B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) - B2.crossSlope + B4.crossSlope)/(((B3.crossSlope - B2.crossSlope)/(B3.stationing - B2.stationing)) - ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)));
                                    if(x2 >= B5.stationing && x2 <= O2.endStationing)
                                    {
                                        let y2 = ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) * (x2 - B5.stationing) + B5.crossSlope; 
                                        rightSide.push(B2, {stationing: x2, crossSlope: y2});
                                    }
                                }
                            }
                        }
                    }
                    else if(B2.stationing >= B5.stationing)
                    {
                        let crossProductA3 = (B2.stationing - B1.stationing) * (B6.crossSlope - B5.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B6.stationing - B6.stationing);
                        if(Math.abs(crossProductA3) > 2e-8)
                        {
                            let x3 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B5.stationing * (B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) - B1.crossSlope + B4.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)));
                            if(x3 >= O2.startStationing && x3 <= O2.endStationing)
                            {
                                let y3 = ((B6.crossSlope - B5.crossSlope)/(B6.stationing - B5.stationing)) * (x3 - B5.stationing) + B5.crossSlope; 
                                rightSide.push({stationing: x3, crossSlope: y3});
                            }
                        }
                    }
                }
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Klotoide" && O3.type === "Rettlinje")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O1.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );

                let A1 = {};
                let A2 = {};
                let A3 = {};

                let B1 = {};
                let B2 = {};
                let B3 = {};

                if(O2.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    
                    if(O2.length >= L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing - L0, crossSlope: 0};
                        A3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing - L0, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                    }
                    else if(O2.length < L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing, crossSlope: 0};
                        A3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        B3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};
                    }
                }
                else if(O2.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    
                    if(O2.length >= L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing - L0, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing - L0, crossSlope: 0};
                        B3 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                    }
                    else if(O2.length < L0 + Lmin)
                    {
                        A2 = {stationing: O2.endStationing, crossSlope: -normalCrossSlope};
                        A3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};

                        B2 = {stationing: O2.endStationing, crossSlope: 0};
                        B3 = {stationing: O2.endStationing + L0, crossSlope: -normalCrossSlope};
                    }
                }

                if(O2.length >= L0 + Lmin)
                {
                    leftSide.push(A1, A2, A3);
                    rightSide.push(B1, B2, B3);
                }
                else if(O2.length < L0 + Lmin)
                {
                    leftSide.push(A1, A2);
                    rightSide.push(B1, B2);
                }

            }
            else if(O1.type === "Sirkelbue" && O2.type === "Klotoide" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.firstRadius);

                let A1 = {};
                let A2 = {};

                let B1 = {};
                let B2 = {};

                if(O2.firstRadius > 0 && O2.secondRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: e2};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: -e2};
                }
                else if(O2.firstRadius > 0 && O2.secondRadius === 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: 0};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: 0};
                }
                else if(O2.firstRadius < 0 && O2.secondRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: -e2};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: e2};
                }
                else if(O2.firstRadius < 0 && O2.secondRadius === 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: 0};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: 0};
                }

                leftSide.push(A1, A2);
                rightSide.push(B1, B2);

            }
            else if(O1.type === "Sirkelbue" && O2.type === "Klotoide" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O3.firstRadius);

                let A1 = {};
                let A2 = {};

                let B1 = {};
                let B2 = {};

                if(O1.firstRadius > 0 && O3.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: e1};
                    A2 = {stationing: O2.endStationing, crossSlope: e2};

                    B1 = {stationing: O2.startStationing, crossSlope: -e1};
                    B2 = {stationing: O2.endStationing, crossSlope: -e2};
                }
                else if(O1.firstRadius < 0 && O3.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing, crossSlope: -e1};
                    A2 = {stationing: O2.endStationing, crossSlope: -e2};

                    B1 = {stationing: O2.startStationing, crossSlope: e1};
                    B2 = {stationing: O2.endStationing, crossSlope: e2};
                }

                leftSide.push(A1, A2);
                rightSide.push(B1, B2);
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue" && O3.type === "Rettlinje")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let c1 = e1 / (e1 + e2);
                let c2 = e2 / (e1 + e2);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin1;
                if(Math.sign(O1.firstRadius) === Math.sign(O2.firstRadius))
                {
                    Lmin1 = calculateSuperelevationRunoffLength(
                            Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius)),
                            Math.abs(calculateCrossSlopeFromRadius(designClass, O2.firstRadius) - calculateCrossSlopeFromRadius(designClass, O1.firstRadius)),
                            wheelbase,
                            relativeVerticalSpeed
                        );
                }
                else if(Math.sign(O1.firstRadius) !== Math.sign(O2.firstRadius))
                {
                    Lmin1 = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, O1.firstRadius) + calculateCrossSlopeFromRadius(designClass, O2.firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
                }
                
                let Lmin2 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    calculateCrossSlopeFromRadius(designClass, O2.firstRadius),
                    wheelbase,
                    relativeVerticalSpeed
                );
                

                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};
                let A5 = {};

                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};
                let B5 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: e1};
                    B1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: -e1};
                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: -e1};
                    B1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: e1};
                }

                if(O2.firstRadius > 0)
                {
                    A2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: e2};
                    A3 = {stationing: O2.endStationing - 0.4 * Lmin2, crossSlope: e2};
                    A4 = {stationing: O2.endStationing + 0.6 * Lmin2 - L0, crossSlope: normalCrossSlope};
                    A5 = {stationing: O2.endStationing + 0.6 * Lmin2 + L0, crossSlope: -normalCrossSlope};

                    B2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: -e2};
                    B3 = {stationing: O2.endStationing - 0.4 * Lmin2, crossSlope: -e2};
                    B4 = {stationing: O2.endStationing + 0.6 * Lmin2 - L0, crossSlope: -normalCrossSlope};
                    B5 = {stationing: O2.endStationing + 0.6 * Lmin2 + L0, crossSlope: -normalCrossSlope};
                }
                else if(O2.firstRadius < 0)
                {
                    A2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: -e2};
                    A3 = {stationing: O2.endStationing - 0.4 * Lmin2, crossSlope: -e2};
                    A4 = {stationing: O2.endStationing + 0.6 * Lmin2 - L0, crossSlope: -normalCrossSlope};
                    A5 = {stationing: O2.endStationing + 0.6 * Lmin2 + L0, crossSlope: -normalCrossSlope};

                    B2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: e2};
                    B3 = {stationing: O2.endStationing - 0.4 * Lmin2, crossSlope: e2};
                    B4 = {stationing: O2.endStationing + 0.6 * Lmin2 - L0, crossSlope: normalCrossSlope};
                    B5 = {stationing: O2.endStationing + 0.6 * Lmin2 + L0, crossSlope: -normalCrossSlope};
                }

                if(e1 === e2 && Lmin1 === 0)
                {
                    if(A2.stationing < A3.stationing)
                    {
                        if(A4.stationing <= O2.endStationing)
                        {
                            if(A3.stationing === A4.stationing) leftSide.push(A2, A3);
                            else leftSide.push(A2, A3, A4);
                        }
                        else if(A4.stationing > O2.endStationing) leftSide.push(A2, A3);
                    }
                    else if(A2.stationing >= A3.stationing)
                    {
                        if(A4.stationing <= O2.endStationing)
                        {
                            if(A2.stationing < A4.stationing) leftSide.push(A2, A4);
                            else if(A2 >= A4.stationing) leftSide.push(A2);
                        }
                        else if(A4.stationing > O2.endStationing) leftSide.push(A2);
                    }

                    if(B2.stationing < B3.stationing)
                    {
                        if(B4.stationing <= O2.endStationing)
                        {
                            if(B3.stationing === B4.stationing) rightSide.push(B2, B3);
                            else rightSide.push(B2, B3, B4);
                        }
                        else if(B4.stationing > O2.endStationing) rightSide.push(B2, B3);
                    }
                    else if(B2.stationing >= B3.stationing)
                    {
                        if(B4.stationing <= O2.endStationing)
                        {
                            if(B2.stationing < B4.stationing) rightSide.push(B2, B4);
                            else if(B2 >= B4.stationing) rightSide.push(B2);
                        }
                        else if(B4.stationing > O2.endStationing) rightSide.push(B2);
                    }
                }
                if(Lmin1 !== 0)
                {
                    if(A2.stationing < A3.stationing)
                    {
                        if(A4.stationing <= O2.endStationing)
                        {
                            if(A3.stationing === A4.stationing) leftSide.push(A2, A3);
                            else leftSide.push(A2, A3, A4);
                        }
                        else if(A4.stationing > O2.endStationing) leftSide.push(A2, A3);
                    }
                    else if(A2.stationing >= A3.stationing)
                    {
                        if(A4.stationing > O2.endStationing)
                        {
                            let crossProductA = (A2.stationing - A1.stationing) * (A4.crossSlope - A3.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A4.stationing - A3.stationing);
                            if(Math.abs(crossProductA) > 2e-8)
                            {
                                let x = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A1.crossSlope + A3.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                                if(x >= O2.startStationing && x <= O2.endStationing)
                                {
                                    let y = ((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) * (x - A1.stationing) + A1.crossSlope;
                                    leftSide.push({stationing: x, crossSlope: y});
                                }
                            }
                        }
                        else if(A4.stationing <= O2.endStationing)
                        {
                            let crossProductA = (A2.stationing - A1.stationing) * (A4.crossSlope - A3.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A4.stationing - A3.stationing);

                            if(Math.abs(crossProductA) <= 2e-8)
                            {
                                let crossProductA1 = (A2.stationing - A1.stationing) * (A5.crossSlope - A4.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A5.stationing - A4.stationing);

                                if(Math.abs(crossProductA1) > 2e-8)
                                {
                                    let x = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A1.crossSlope + A4.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                                    if(x >= A4.stationing && x <= O2.endStationing)
                                    {
                                        let y = ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) * (x - A4.stationing) + A4.crossSlope;
                                        leftSide.push({stationing: x, crossSlope: y});
                                    }
                                }
                            }
                            else if(Math.abs(crossProductA) > 2e-8)
                            {
                                let x = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A1.crossSlope + A3.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                                if(x >= O2.startStationing && x < A4.stationing)
                                {
                                    let y = ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) * (x - A3.stationing) + A3.crossSlope;
                                    leftSide.push({stationing: x, crossSlope: y}, A4);
                                }
                                else if(x >= A4.stationing && x <= O2.endStationing)
                                {
                                    let x1 = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A4.stationing * (A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) - A1.crossSlope + A4.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)));
                                    if(x1 >= A4.stationing && x1 <= O2.endStationing)
                                    {
                                        let y = ((A5.crossSlope - A4.crossSlope)/(A5.stationing - A4.stationing)) * (x1 - A4.stationing) + A4.crossSlope;
                                        leftSide.push({stationing: x, crossSlope: y});
                                    }
                                }
                            }
                        }
                    }

                    if(B2.stationing < B3.stationing)
                    {
                        if(B4.stationing <= O2.endStationing)
                        {
                            if(B3.stationing === B4.stationing) rightSide.push(B2, B3);
                            else rightSide.push(B2, B3, B4);
                        }
                        else if(B4.stationing > O2.endStationing) rightSide.push(B2, B3);
                    }
                    else if(B2.stationing >= B3.stationing)
                    {
                        if(B4.stationing > O2.endStationing)
                        {
                            let crossProductA = (B2.stationing - B1.stationing) * (B4.crossSlope - B3.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B4.stationing - B3.stationing);
                            if(Math.abs(crossProductA) > 2e-8)
                            {
                                let x = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - B1.crossSlope + B3.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                                if(x >= O2.startStationing && x <= O2.endStationing)
                                {
                                    let y = ((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) * (x - B1.stationing) + B1.crossSlope;
                                    rightSide.push({stationing: x, crossSlope: y});
                                }
                            }
                        }
                        else if(B4.stationing <= O2.endStationing)
                        {
                            let crossProductA = (B2.stationing - B1.stationing) * (B4.crossSlope - B3.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B4.stationing - B3.stationing);

                            if(Math.abs(crossProductA) <= 2e-8)
                            {
                                let crossProductA1 = (B2.stationing - B1.stationing) * (B5.crossSlope - B4.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B5.stationing - B4.stationing);

                                if(Math.abs(crossProductA1) > 2e-8)
                                {
                                    let x = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B1.crossSlope + B4.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                                    if(x >= B4.stationing && x <= O2.endStationing)
                                    {
                                        let y = ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) * (x - B4.stationing) + B4.crossSlope;
                                        rightSide.push({stationing: x, crossSlope: y});
                                    }
                                }
                            }
                            else if(Math.abs(crossProductA) > 2e-8)
                            {
                                let x = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - B1.crossSlope + B3.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                                if(x >= O2.startStationing && x < B4.stationing)
                                {
                                    let y = ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) * (x - B3.stationing) + B3.crossSlope;
                                    rightSide.push({stationing: x, crossSlope: y}, B4);
                                }
                                else if(x >= B4.stationing && x <= O2.endStationing)
                                {
                                    let x1 = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B4.stationing * (B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) - B1.crossSlope + B4.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)));
                                    if(x1 >= B4.stationing && x1 <= O2.endStationing)
                                    {
                                        let y = ((B5.crossSlope - B4.crossSlope)/(B5.stationing - B4.stationing)) * (x1 - B4.stationing) + B4.crossSlope;
                                        rightSide.push({stationing: x, crossSlope: y});
                                    }
                                }
                            }
                        }
                    }
                }
                
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue" && O3.type === "Klotoide")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);

                let c1 = e1 / (e1 + e2);
                let c2 = e2 / (e1 + e2);

                let L0 = calculateSuperelevationRunoffLength(
                    speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius),
                    normalCrossSlope,
                    wheelbase,
                    relativeVerticalSpeed
                );

                let Lmin1;
                if(Math.sign(O1.firstRadius) === Math.sign(O2.firstRadius))
                {
                    Lmin1 = calculateSuperelevationRunoffLength(
                            Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius)),
                            Math.abs(calculateCrossSlopeFromRadius(designClass, O2.firstRadius) - calculateCrossSlopeFromRadius(designClass, O1.firstRadius)),
                            wheelbase,
                            relativeVerticalSpeed
                        );
                }
                else if(Math.sign(O1.firstRadius) !== Math.sign(O2.firstRadius))
                {
                    Lmin1 = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, O1.firstRadius) + calculateCrossSlopeFromRadius(designClass, O2.firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
                }

                let A1 = {};
                let A2 = {};
                let A3 = {};

                let B1 = {};
                let B2 = {};
                let B3 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope : e1};
                    B1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope : -e1};
                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope : -e1};
                    B1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope : e1};
                }

                if(O2.firstRadius > 0)
                {
                    A2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: e2};
                    A3 = {stationing: O2.endStationing, crossSlope: e2};

                    B2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: -e2};
                    B3 = {stationing: O2.endStationing, crossSlope: -e2};
                }
                else if(O2.firstRadius < 0)
                {
                    A2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: -e2};
                    A3 = {stationing: O2.endStationing, crossSlope: -e2};

                    B2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: e2};
                    B3 = {stationing: O2.endStationing, crossSlope: e2};
                }

                if(A2.stationing < A3.stationing) leftSide.push(A2, A3);
                else if(A2.stationing >= A3.stationing) leftSide.push(A3);

                if(B2.stationing < B3.stationing) rightSide.push(B2, B3);
                else if(B2.stationing >= B3.stationing) rightSide.push(B3);
            }
            else if(O1.type === "Sirkelbue" && O2.type === "Sirkelbue" && O3.type === "Sirkelbue")
            {
                let e1 = calculateCrossSlopeFromRadius(designClass, O1.firstRadius);
                let e2 = calculateCrossSlopeFromRadius(designClass, O2.firstRadius);
                let e3 = calculateCrossSlopeFromRadius(designClass, O3.firstRadius);
                let c1 = e1 / (e1 + e2);
                let c2 = e2 / (e1 + e2);

                let c3 = e2 / (e2 + e3);
                let c4 = e3 / (e2 + e3);

                let Lmin1;
                if(Math.sign(O1.firstRadius) === Math.sign(O2.firstRadius))
                {
                    Lmin1 = calculateSuperelevationRunoffLength(
                            Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius)),
                            Math.abs(calculateCrossSlopeFromRadius(designClass, O2.firstRadius) - calculateCrossSlopeFromRadius(designClass, O1.firstRadius)),
                            wheelbase,
                            relativeVerticalSpeed
                        );
                }
                else if(Math.sign(O1.firstRadius) !== Math.sign(O2.firstRadius))
                {
                    Lmin1 = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O1.firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, O2.firstRadius) + calculateCrossSlopeFromRadius(designClass, O1.firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
                }

                let Lmin2;
                if(Math.sign(O2.firstRadius) === Math.sign(O3.firstRadius))
                {
                    Lmin2 = calculateSuperelevationRunoffLength(
                            Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius)),
                            Math.abs(calculateCrossSlopeFromRadius(designClass, O3.firstRadius) - calculateCrossSlopeFromRadius(designClass, O2.firstRadius)),
                            wheelbase,
                            relativeVerticalSpeed
                        );
                }
                else if(Math.sign(O2.firstRadius) !== Math.sign(O3.firstRadius))
                {
                    Lmin2 = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O3.firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, O2.firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, O3.firstRadius) + calculateCrossSlopeFromRadius(designClass, O2.firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
                }

                let A1 = {};
                let A2 = {};
                let A3 = {};
                let A4 = {};

                let B1 = {};
                let B2 = {};
                let B3 = {};
                let B4 = {};

                if(O1.firstRadius > 0)
                {
                    A1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: e1};
                    B1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: -e1};
                }
                else if(O1.firstRadius < 0)
                {
                    A1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: -e1};
                    B1 = {stationing: O2.startStationing - c1 * Lmin1, crossSlope: e1};
                }

                if(O2.firstRadius > 0)
                {
                    A2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: e2};
                    A3 = {stationing: O2.endStationing - c3 * Lmin2, crossSlope: e2};

                    B2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: -e2};
                    B3 = {stationing: O2.endStationing - c3 * Lmin2, crossSlope: -e2};
                }
                if(O2.firstRadius < 0)
                {
                    A2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: -e2};
                    A3 = {stationing: O2.endStationing - c3 * Lmin2, crossSlope: -e2};

                    B2 = {stationing: O2.startStationing + c2 * Lmin1, crossSlope: e2};
                    B3 = {stationing: O2.endStationing - c3 * Lmin2, crossSlope: e2};
                }

                if(O3.firstRadius > 0)
                {
                    A4 = {stationing: O2.endStationing + c4 * Lmin2, crossSlope: e3};
                    B4 = {stationing: O2.endStationing + c4 * Lmin2, crossSlope: -e3};
                }
                else if(O3.firstRadius < 0)
                {
                    A4 = {stationing: O2.endStationing + c4 * Lmin2, crossSlope: -e3};
                    B4 = {stationing: O2.endStationing + c4 * Lmin2, crossSlope: e3};
                }

                if(A2.stationing < A3.startElevation) leftSide.push(A2, A3);
                else if(A2.stationing > O2.endStationing && Lmin2 === 0) leftSide.push(A3);
                else if(A3.stationing < O2.startStationing && Lmin1 === 0) leftSide.push(A2);
                else if(A2.stationing >= A3.stationing)
                {
                    let crossProductA = (A2.stationing - A1.stationing) * (A4.crossSlope - B3.crossSlope) - (A2.crossSlope - A1.crossSlope) * (A4.stationing - A3.stationing);
                    if(Math.abs(crossProductA) > 2e-8)
                    {
                        let x = ((A1.stationing * (A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - (A3.stationing * (A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) - A1.crossSlope + A3.crossSlope)/(((A2.crossSlope - A1.crossSlope)/(A2.stationing - A1.stationing)) - ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)));
                        if(x >= O2.startStationing && x <= O2.endStationing)
                        {
                            let y = ((A4.crossSlope - A3.crossSlope)/(A4.stationing - A3.stationing)) * (x - A3.stationing) + A3.crossSlope;
                            leftSide.push({stationing: x, crossSlope: y});
                        }
                    }
                }

                if(B2.stationing < B3.startElevation) rightSide.push(B2, B3);
                else if(B2.stationing > O2.endStationing && Lmin2 === 0) rightSide.push(B3);
                else if(B3.stationing < O2.startStationing && Lmin1 === 0) rightSide.push(B2);
                else if(B2.stationing >= B3.stationing)
                {
                    let crossProductB = (B2.stationing - B1.stationing) * (B4.crossSlope - B3.crossSlope) - (B2.crossSlope - B1.crossSlope) * (B4.stationing - B3.stationing);
                    if(Math.abs(crossProductB) > 2e-8)
                    {
                        let x = ((B1.stationing * (B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - (B3.stationing * (B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) - B1.crossSlope + B3.crossSlope)/(((B2.crossSlope - B1.crossSlope)/(B2.stationing - B1.stationing)) - ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)));
                        if(x >= O2.startStationing && x <= O2.endStationing)
                        {
                            let y = ((B4.crossSlope - B3.crossSlope)/(B4.stationing - B3.stationing)) * (x - B3.stationing) + B3.crossSlope;
                            rightSide.push({stationing: x, crossSlope: y});
                        }
                    }
                }

            }
        } 
    }
    
    // #endregion

    // #region inserting startpoints
    if(geometry.length >= 3)
    {
        
        if(geometry[0].type === "Rettlinje" && geometry[1].type === "Klotoide")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[1].secondRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[1].secondRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[1].secondRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[1].secondRadius),
                wheelbase,
                relativeVerticalSpeed
            );


            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[1].secondRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}

                if(geometry[1].length >= L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                    A3 = {stationing: geometry[0].endStationing + L0, crossSlope: 0};

                    B2 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                    B3 = {stationing: geometry[0].endStationing + L0, crossSlope: -normalCrossSlope};
                }
                else if(geometry[1].length < L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing - L0, crossSlope: -normalCrossSlope}
                    A3 = {stationing: geometry[0].endStationing, crossSlope: 0};

                    B2 = {stationing: geometry[0].endStationing - L0, crossSlope: -normalCrossSlope}
                    B3 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope};
                }
            }
            else if(geometry[1].secondRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}

                if(geometry[1].length >= L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                    A3 = {stationing: geometry[0].endStationing + L0, crossSlope: -normalCrossSlope};

                    B2 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                    B3 = {stationing: geometry[0].endStationing + L0, crossSlope: 0};
                }
                else if(geometry[1].length < L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing - L0, crossSlope: -normalCrossSlope}
                    A3 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope};

                    B2 = {stationing: geometry[0].endStationing - L0, crossSlope: -normalCrossSlope}
                    B3 = {stationing: geometry[0].endStationing, crossSlope: 0};
                }
            }

            if(geometry[1].length >= L0 + Lmin)
            {
                leftSide.unshift(A1, A2);
                rightSide.unshift(B1, B2);
            }
            else if(geometry[1].length < L0 + Lmin)
            {
                if(A1.stationing < A2.stationing) leftSide.unshift(A1, A2, A3);
                else if(A1.stationing >= A2.stationing) leftSide.unshift(A1, A3);

                if(B1.stationing < B2.stationing) rightSide.unshift(B1, B2, B3);
                else if(B1.stationing >= B2.stationing) rightSide.unshift(B1, B3);
            }
        }
        else if(geometry[0].type === "Rettlinje" && geometry[1].type === "Sirkelbue")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[1].firstRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[1].firstRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[1].firstRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope};
                A2 = {stationing: geometry[0].endStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                A3 = {stationing: geometry[0].endStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope};

                B1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope};
                B2 = {stationing: geometry[0].endStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                B3 = {stationing: geometry[0].endStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};
            }
            else if(geometry[1].firstRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope};
                A2 = {stationing: geometry[0].endStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                A3 = {stationing: geometry[0].endStationing - 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};

                B1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope};
                B2 = {stationing: geometry[0].endStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                B3 = {stationing: geometry[0].endStationing - 0.6 * Lmin + L0, crossSlope: normalCrossSlope};
            }

            if(L0 > 0.6 * Lmin)
            {
                if(A1.stationing < A2.stationing) leftSide.unshift(A1, A2);
                else if(A1.stationing >= A2.stationing) leftSide.unshift(A1);

                if(B1.stationing < B2.stationing) rightSide.unshift(B1, B2);
                else if(B1.stationing >= B2.stationing) rightSide.unshift(B1);
            }
            else if(L0 <= 0.6 * Lmin)
            {
                if(A1.stationing < A2.stationing && A1.stationing < A3.stationing) leftSide.unshift(A1, A2, A3);
                else if(A1.stationing >= A2.stationing && A1.stationing < A3.stationing) leftSide.unshift(A1, A3);
                else if(A1.stationing >= A2.stationing && A1.stationing >= A3.stationing) leftSide.unshift(A1);

                if(B1.stationing < B2.stationing && B1.stationing < B3.stationing) rightSide.unshift(B1, B2, B3);
                else if(B1.stationing >= B2.stationing && B1.stationing < B3.stationing) rightSide.unshift(B1, B3);
                else if(B1.stationing >= A2.stationing && B1.stationing >= B3.stationing) rightSide.unshift(B1);
            }

        }
        else if(geometry[0].type === "Klotoide" && geometry[1].type === "Rettlinje")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[0].firstRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[0].firstRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[0].firstRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1};
                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1};

                if(geometry[0].length >= L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing - L0, crossSlope: 0}
                    A3 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}

                    B2 = {stationing: geometry[0].endStationing - L0, crossSlope: -normalCrossSlope}
                    B3 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                }
                else if(geometry[0].length < L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing, crossSlope: 0}
                    A3 = {stationing: geometry[0].endStationing + L0, crossSlope: -normalCrossSlope}

                    B2 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                    B3 = {stationing: geometry[0].endStationing + L0, crossSlope: -normalCrossSlope}
                }
            }
            else if(geometry[0].firstRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
                B1 = {stationing: geometry[0].startStationing, crossSlope: e1};

                if(geometry[0].length >= L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing - L0, crossSlope: -normalCrossSlope}
                    A3 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}

                    B2 = {stationing: geometry[0].endStationing - L0, crossSlope: 0}
                    B3 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                }
                else if(geometry[0].length < L0 + Lmin)
                {
                    A2 = {stationing: geometry[0].endStationing, crossSlope: -normalCrossSlope}
                    A3 = {stationing: geometry[0].endStationing + L0, crossSlope: -normalCrossSlope}

                    B2 = {stationing: geometry[0].endStationing, crossSlope: 0}
                    B3 = {stationing: geometry[0].endStationing + L0, crossSlope: -normalCrossSlope}
                }
            }

            if(geometry[0].length >= L0 + Lmin)
            {
                leftSide.unshift(A1, A2, A3);
                rightSide.unshift(B1, B2, B3);
            }
            else if(geometry[0].length < L0 + Lmin)
            {
                leftSide.unshift(A1, A2);
                rightSide.unshift(B1, B2);
            }
        }
        else if(geometry[0].type === "Klotoide" && geometry[1].type === "Klotoide")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius);
            let e2 =  calculateCrossSlopeFromRadius(designClass, geometry[0].secondRadius);

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};

            if(geometry[0].firstRadius === 0 && geometry[0].secondRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: normalCrossSlope}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}

                A2 = {stationing: geometry[0].endStationing, crossSlope: e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
            }
            else if(geometry[0].firstRadius === 0 && geometry[0].secondRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}
                B1 = {stationing: geometry[0].startStationing, crossSlope: normalCrossSlope}

                A2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: e2}
            }
            else if(geometry[0].firstRadius > 0 && geometry[0].secondRadius === 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1}

                A2 = {stationing: geometry[0].endStationing, crossSlope: 0}
                B2 = {stationing: geometry[0].endStationing, crossSlope: 0}
            }
            else if(geometry[0].firstRadius < 0 && geometry[0].secondRadius === 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1}
                B1 = {stationing: geometry[0].startStationing, crossSlope: e1}

                A2 = {stationing: geometry[0].endStationing, crossSlope: 0}
                B2 = {stationing: geometry[0].endStationing, crossSlope: 0}
            }
            else if(geometry[0].firstRadius < 0 && geometry[0].secondRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1}
                B1 = {stationing: geometry[0].startStationing, crossSlope: e1}

                A2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: e2}
            }
            else if(geometry[0].firstRadius > 0 && geometry[0].secondRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1}

                A2 = {stationing: geometry[0].endStationing, crossSlope: e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
            }

            leftSide.unshift(A1, A2);
            rightSide.unshift(B1, B2);
        }
        else if(geometry[0].type === "Klotoide" && geometry[1].type === "Sirkelbue")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius);
            let e2 =  calculateCrossSlopeFromRadius(designClass, geometry[0].secondRadius);

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};

            if(geometry[0].firstRadius === 0 && geometry[0].secondRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: normalCrossSlope}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}

                A2 = {stationing: geometry[0].endStationing, crossSlope: e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
            }
            else if(geometry[0].firstRadius === 0 && geometry[0].secondRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -normalCrossSlope}
                B1 = {stationing: geometry[0].startStationing, crossSlope: normalCrossSlope}

                A2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: e2}
            }
            else if(geometry[0].firstRadius < 0 && geometry[0].secondRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1}
                B1 = {stationing: geometry[0].startStationing, crossSlope: e1}

                A2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: e2}
            }
            else if(geometry[0].firstRadius > 0 && geometry[0].secondRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1}
                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1}

                A2 = {stationing: geometry[0].endStationing, crossSlope: e2}
                B2 = {stationing: geometry[0].endStationing, crossSlope: -e2}
            }

            leftSide.unshift(A1, A2);
            rightSide.unshift(B1, B2);
        }
        else if(geometry[0].type === "Sirkelbue" && geometry[1].type === "Rettlinje")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[0].firstRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[0].firstRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[0].firstRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[0].startStationing - 0.4 * Lmin, crossSlope: e1};
                A3 = {stationing: geometry[0].startStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope};

                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[0].startStationing - 0.4 * Lmin, crossSlope: -e1};
                B3 = {stationing: geometry[0].startStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
            }
            else if(geometry[0].firstRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[0].startStationing - 0.4 * Lmin, crossSlope: -e1};
                A3 = {stationing: geometry[0].startStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope};

                B1 = {stationing: geometry[0].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[0].startStationing - 0.4 * Lmin, crossSlope: e1};
                B3 = {stationing: geometry[0].startStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
            }

            if(L0 >= 0.6 * Lmin)
            {
                if(A1.stationing < A2.stationing && A1.stationing < A3.stationing) leftSide.unshift(A1, A2, A3);
                else if(A1.stationing >= A2.stationing && A1.stationing < A3.stationing) leftSide.unshift(A1, A3);
                else if(A1.stationing >= A2.stationing && A1.stationing >= A3.stationing) leftSide.unshift(A1);

                if(B1.stationing < B2.stationing && B1.stationing < B3.stationing) leftSide.unshift(B1, B2, B3);
                else if(B1.stationing >= B2.stationing && B1.stationing < B3.stationing) leftSide.unshift(B1, B3);
                else if(B1.stationing >= B2.stationing && B1.stationing >= B3.stationing) leftSide.unshift(B1);
            }
            else if(L0 < 0.6 * Lmin)
            {
                if(A1.stationing < A2.stationing) leftSide.unshift(A1, A2);
                else if(A1.stationing >= A2.stationing) leftSide.unshift(A1);

                if(B1.stationing < B2.stationing) leftSide.unshift(B1, B2);
                else if(B1.stationing >= B2.stationing) rightSide.unshift(B1);
            }
        }
        else if(geometry[0].type === "Sirkelbue" && geometry[1].type === "Klotoide")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius);

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};

            if(geometry[0].firstRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[0].endStationing, crossSlope: e1};

                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[0].endStationing, crossSlope: -e1};
            }
            else if(geometry[0].firstRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[0].endStationing, crossSlope: -e1};

                B1 = {stationing: geometry[0].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[0].endStationing, crossSlope: e1};
            }

            leftSide.unshift(A1, A2);
            rightSide.unshift(B1, B2);
        }
        else if(geometry[0].type === "Sirkelbue" && geometry[1].type === "Sirkelbue")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius);
            let e2 =  calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius);

            let c1 = e1 / (e1 + e2);

            let Lmin;
            if(Math.sign(geometry[0].firstRadius) === Math.sign(geometry[1].firstRadius))
            {
                Lmin = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[0].firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[1].firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius) - calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
            }
            else if(Math.sign(geometry[0].firstRadius) !== Math.sign(geometry[1].firstRadius))
            {
                Lmin = calculateSuperelevationRunoffLength(
                    Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass,geometry[0].firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[1].firstRadius)),
                    Math.abs(calculateCrossSlopeFromRadius(designClass, geometry[0].firstRadius) + calculateCrossSlopeFromRadius(designClass, geometry[1].firstRadius)),
                    wheelbase,
                    relativeVerticalSpeed
                );
            }

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};
            


            if(geometry[0].firstRadius > 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: e1};
                B1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
            }
            else if(geometry[0].firstRadius < 0)
            {
                A1 = {stationing: geometry[0].startStationing, crossSlope: -e1};
                B1 = {stationing: geometry[0].startStationing, crossSlope: e1};
            }

            if(geometry[1].firstRadius > 0)
            {
                A2 = {stationing: geometry[0].endStationing - c1 * Lmin, crossSlope: e1};
                B2 = {stationing: geometry[0].endStationing - c1 * Lmin, crossSlope: -e1};
            }
            else if(geometry[1].firstRadius < 0)
            {
                A2 = {stationing: geometry[0].endStationing - c1 * Lmin, crossSlope: -e1};
                B2 = {stationing: geometry[0].endStationing - c1 * Lmin, crossSlope: e1};
            }

            if(A1.stationing < A2.stationing) leftSide.unshift(A1, A2);
            else if(A1.stationing >= A2.stationing) leftSide.unshift(A1);

            if(B1.stationing < B2.stationing) rightSide.unshift(B1, B2);
            else if(B1.stationing >= B2.stationing) rightSide.unshift(B1);
        }

        if(leftSide[0].stationing < geometry[0].startStationing)
        {
            let y = ((leftSide[1].crossSlope - leftSide[0].crossSlope)/(leftSide[1].stationing - leftSide[0].stationing)) * (geometry[0].startStationing - leftSide[0].stationing) + leftSide[0].crossSlope;
            leftSide[0] = {stationing: geometry[0].startStationing, crossSlope: y};
        }

        if(rightSide[0].stationing < geometry[0].startStationing)
        {
            let y = ((rightSide[1].crossSlope - rightSide[0].crossSlope)/(rightSide[1].stationing - rightSide[0].stationing)) * (geometry[0].startStationing - rightSide[0].stationing) + rightSide[0].crossSlope;
            rightSide[0] = {stationing: geometry[0].startStationing, crossSlope: y};
        }
        
    }
    // #endregion

    // #region inserting endpoints
    if(geometry.length >= 3)
    {
        if(geometry[geometry.length-2].type === "Rettlinje" && geometry[geometry.length-1].type === "Klotoide")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].secondRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-1].secondRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-1].secondRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].secondRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[geometry.length-1].secondRadius > 0)
            {
                if(geometry[geometry.length-1].length >= L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    A2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: 0};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};

                    B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    B2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: -normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};
                }
                else if(geometry[geometry.length-1].length < L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: -normalCrossSlope};
                    A2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};

                    B1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: -normalCrossSlope};
                    B2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};
                }
            }
            else if(geometry[geometry.length-1].secondRadius < 0)
            {
                if(geometry[geometry.length-1].length >= L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    A2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: -normalCrossSlope};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};

                    B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    B2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: 0};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};
                }
                else if(geometry[geometry.length-1].length < L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: -normalCrossSlope};
                    A2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};

                    B1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: -normalCrossSlope};
                    B2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};
                }
            }

            if(geometry[geometry.length-1].length >= L0 + Lmin)
            {
                leftSide.push(A1, A2, A3);
                rightSide.push(B1, B2, B3);
            }
            else if(geometry[geometry.length-1].length < L0 + Lmin)
            {
                leftSide.push(A2, A3);
                rightSide.push(B2, B3);
            }
        }
        else if(geometry[geometry.length-2].type === "Rettlinje" && geometry[geometry.length-1].type === "Sirkelbue")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-1].firstRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-1].firstRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[geometry.length-1].firstRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin - L0, crossSlope: normalCrossSlope};
                A2 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin + L0, crossSlope: e1};
                A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};

                B1 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                B2 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin + L0, crossSlope: -e1};
                B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};
            }
            else if(geometry[geometry.length-1].firstRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                A2 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin + L0, crossSlope: -e1};
                A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};

                B1 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin - L0, crossSlope: normalCrossSlope};
                B2 = {stationing: geometry[geometry.length-1].startStationing - 0.6 * Lmin + L0, crossSlope: e1};
                B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};
            }

            if(L0 >= Lmin)
            {
                leftSide.push(A1, A2, A3);
                rightSide.push(B1, B2, B3);
            }
            else if(L0 < Lmin)
            {
                leftSide.push(A2, A3);
                rightSide.push(B2, B3);
            }
        }
        else if(geometry[geometry.length-2].type === "Klotoide" && geometry[geometry.length-1].type === "Rettlinje")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-2].firstRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-2].firstRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[geometry.length-2].firstRadius > 0)
            {
                if(geometry[geometry.length-2].length >= L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: 0};
                    A2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};

                    B1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: -normalCrossSlope};
                    B2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};
                }
                else if(geometry[geometry.length-2].length < L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                    A2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: -normalCrossSlope};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};

                    B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    B2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: -normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};
                }
            }
            else if(geometry[geometry.length-2].firstRadius < 0)
            {
                if(geometry[geometry.length-2].length >= L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: -normalCrossSlope};
                    A2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};

                    B1 = {stationing: geometry[geometry.length-1].startStationing - L0, crossSlope: 0};
                    B2 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};
                }
                else if(geometry[geometry.length-2].length < L0 + Lmin)
                {
                    A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -normalCrossSlope};
                    A2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: -normalCrossSlope};
                    A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};

                    B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                    B2 = {stationing: geometry[geometry.length-1].startStationing + L0, crossSlope: -normalCrossSlope};
                    B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};
                }
            }

            if(geometry[geometry.length-2].length >= L0 + Lmin)
            {
                leftSide.push(A2, A3);
                rightSide.push(B2, B3);
            }
            if(geometry[geometry.length-2].length < L0 + Lmin)
            {
                if(A2.stationing < A3.stationing) leftSide.push(A1, A2, A3);
                else if(A2.stationing >= A3.stationing) leftSide.push(A1, A3);

                if(B2.stationing < B3.stationing) rightSide.push(B1, B2, B3);
                else if(B2.stationing >= B3.stationing) rightSide.push(B1, B3);
            }
        }
        else if(geometry[geometry.length-2].type === "Klotoide" && geometry[geometry.length-1].type === "Klotoide")
        {
            let e1 = calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius);
            let e2 = calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].secondRadius);

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};
            
            if(geometry[geometry.length-1].firstRadius === 0 && geometry[geometry.length-1].secondRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2};
            }
            else if(geometry[geometry.length-1].firstRadius === 0 && geometry[geometry.length-1].secondRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: 0};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2};
            }
            else if(geometry[geometry.length-1].firstRadius > 0 && geometry[geometry.length-1].secondRadius === 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};
            }
            else if(geometry[geometry.length-1].firstRadius < 0 && geometry[geometry.length-1].secondRadius === 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};
            }
            else if(geometry[geometry.length-1].firstRadius < 0 && geometry[geometry.length-1].secondRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2};
            }
            else if(geometry[geometry.length-1].firstRadius > 0 && geometry[geometry.length-1].secondRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2};
            }

            leftSide.push(A1, A2);
            rightSide.push(B1, B2);
        }
        else if(geometry[geometry.length-2].type === "Klotoide" && geometry[geometry.length-1].type === "Sirkelbue")
        {
            let e1 = calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius);

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};
            
            if(geometry[geometry.length-1].firstRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};
            }
            else if(geometry[geometry.length-1].firstRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e1};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e1};
            }

            leftSide.push(A1, A2);
            rightSide.push(B1, B2);
        }
        else if(geometry[geometry.length-2].type === "Sirkelbue" && geometry[geometry.length-1].type === "Rettlinje")
        {
            let e1 = calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius);

            let L0 = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-2].firstRadius),
                normalCrossSlope,
                wheelbase,
                relativeVerticalSpeed
            );

            let Lmin = calculateSuperelevationRunoffLength(
                speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-2].firstRadius),
                calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius),
                wheelbase,
                relativeVerticalSpeed
            );

            let A1 = {};
            let A2 = {};
            let A3 = {};

            let B1 = {};
            let B2 = {};
            let B3 = {};

            if(geometry[geometry.length-2].firstRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope};
                A2 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};
                A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};

                B1 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                B2 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};
                B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};
            }
            else if(geometry[geometry.length-2].firstRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin - L0, crossSlope: -normalCrossSlope};
                A2 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};
                A3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};

                B1 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin - L0, crossSlope: normalCrossSlope};
                B2 = {stationing: geometry[geometry.length-1].startStationing + 0.6 * Lmin + L0, crossSlope: -normalCrossSlope};
                B3 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -normalCrossSlope};
            }

            if(L0 <= 0.6 * Lmin)
            {
                if(A1.stationing < A3.stationing && A2.stationing < A3.stationing) leftSide.push(A1, A2, A3);
                else if(A1.stationing < A3.stationing && A2.stationing >= A3.stationing) leftSide.push(A1, A3);
                else if(A1.stationing >= A3.stationing && A2.stationing >= A3.stationing) leftSide.push(A1);

                if(B1.stationing < B3.stationing && B2.stationing < B3.stationing) rightSide.push(B1, B2, B3);
                else if(B1.stationing < B3.stationing && B2.stationing >= B3.stationing) rightSide.push(B1, B3);
                else if(B1.stationing >= B3.stationing && B2.stationing >= B3.stationing) rightSide.push(B1);
            }
            else if(L0 > 0.6 * Lmin)
            {
                if(A2.stationing < A3.stationing) leftSide.push(A2, A3);
                else if(A2.stationing > A3.stationing) leftSide.push(A3);

                if(B2.stationing < B3.stationing) rightSide.push(B2, B3);
                else if(B2.stationing > B3.stationing) rightSide.push(B3);
            }
        }
        else if(geometry[geometry.length-2].type === "Sirkelbue" && geometry[geometry.length-1].type === "Klotoide")
        {
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius);
            let e2 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].secondRadius);

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};

            if(geometry[geometry.length-1].firstRadius > 0 && geometry[geometry.length-1].secondRadius === 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};
            }
            else if(geometry[geometry.length-1].firstRadius < 0 && geometry[geometry.length-1].secondRadius === 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: 0};
            }
            else if(geometry[geometry.length-1].firstRadius > 0 && geometry[geometry.length-1].secondRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2};
            }
            else if(geometry[geometry.length-1].firstRadius < 0 && geometry[geometry.length-1].secondRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: -e1};
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2};

                B1 = {stationing: geometry[geometry.length-1].startStationing, crossSlope: e1};
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2};
            }

            leftSide.push(A1, A2);
            rightSide.push(B1, B2);

        }
        else if(geometry[geometry.length-2].type === "Sirkelbue" && geometry[geometry.length-1].type === "Sirkelbue")
        {
            
            let e1 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius);
            let e2 =  calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius);

            let c1 = e2 / (e1 + e2);

            let Lmin;
            if(Math.sign(geometry[geometry.length-2].firstRadius) === Math.sign(geometry[geometry.length-1].firstRadius))
            {
                Lmin = calculateSuperelevationRunoffLength(
                        Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-2].firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-1].firstRadius)),
                        Math.abs(calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius) - calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius)),
                        wheelbase,
                        relativeVerticalSpeed
                    );
            }
            else if(Math.sign(geometry[geometry.length-2].firstRadius) !== Math.sign(geometry[geometry.length-1].firstRadius))
            {
                Lmin = calculateSuperelevationRunoffLength(
                    Math.max(speedlimit + speedAddition + calculateSpeedProfileAddition(designClass,geometry[geometry.length-2].firstRadius), speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, geometry[geometry.length-1].firstRadius)),
                    Math.abs(calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-2].firstRadius) + calculateCrossSlopeFromRadius(designClass, geometry[geometry.length-1].firstRadius)),
                    wheelbase,
                    relativeVerticalSpeed
                );
            }

            let A1 = {};
            let A2 = {};

            let B1 = {};
            let B2 = {};

            if(geometry[geometry.length-1].firstRadius > 0 && geometry[geometry.length-2].firstRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: e2}
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2}

                B1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: -e2}
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2}
            }
            else if(geometry[geometry.length-1].firstRadius > 0 && geometry[geometry.length-2].firstRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: e2}
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2}

                B1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: -e2}
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2}
            }
            else if(geometry[geometry.length-1].firstRadius < 0 && geometry[geometry.length-2].firstRadius > 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: -e2}
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2}

                B1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: e2}
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2}
            }
            else if(geometry[geometry.length-1].firstRadius < 0 && geometry[geometry.length-2].firstRadius < 0)
            {
                A1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: -e2}
                A2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: -e2}

                B1 = {stationing: geometry[geometry.length-1].startStationing + c1 * Lmin, crossSlope: e2}
                B2 = {stationing: geometry[geometry.length-1].endStationing, crossSlope: e2}
            }

            if(A1.stationing < A2.stationing) leftSide.push(A1, A2);
            else if(A1.stationing >= A2.stationing) leftSide.push(A2);

            if(B1.stationing < B2.stationing) rightSide.push(B1, B2);
            else if(B1.stationing >= B2.stationing) rightSide.push(B2);
        }   
    }
    // #endregion

    // #region removing duplicates
    tempLeftSide = [];

    let lastStationingLeft = null;

    for (let i = 0; i < leftSide.length; i++)
    {
        let current = leftSide[i];

        if (current.stationing !== lastStationingLeft)
        {
            tempLeftSide.push(current);
            lastStationingLeft = current.stationing;
        }
    }

    leftSide = tempLeftSide;

    // ***

    tempRightSide = [];

    let lastStationingRight = null;

    for (let i = 0; i < rightSide.length; i++)
    {
        let current = rightSide[i];

        if (current.stationing !== lastStationingRight)
        {
            tempRightSide.push(current);
            lastStationingRight = current.stationing;
        }
    }

    rightSide = tempRightSide;

    // #endregion

    // #region removing collisions

    // #endregions

    // #region checking relative vertical speed
    for(let i = 0; i < leftSide.length-1; i++)
    {
        let objectBackward = geometry.find(obj => obj.startStationing <= leftSide[i].stationing && obj.endStationing >= leftSide[i].stationing);
        let objectForward = geometry.find(obj => obj.startStationing <= leftSide[i+1].stationing && obj.endStationing >= leftSide[i+1].stationing);
        let firstRadius;
        let secondRadius;

        if(objectForward.type === "Rettlinje") firstRadius = 0;
        else if(objectForward.type === "Sirkelbue") firstRadius = objectForward.firstRadius;
        else if(objectForward.type === "Klotoide") firstRadius = Math.max(Math.abs(objectForward.firstRadius), Math.abs(objectForward.secondRadius));

        if(objectBackward.type === "Rettlinje") secondRadius = 0;
        else if(objectBackward.type === "Sirkelbue") secondRadius = objectBackward.firstRadius;
        else if(objectBackward.type === "Klotoide") secondRadius = Math.max(Math.abs(objectBackward.firstRadius), Math.abs(objectBackward.secondRadius));

        let objectSpeed = speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, Math.max(firstRadius, secondRadius));
        if(Math.abs(leftSide[i+1].stationing - leftSide[i].stationing) !== 0)
        {
            let calculatedRelativeVerticalSpeed = (objectSpeed * wheelbase * Math.abs(leftSide[i+1].crossSlope - leftSide[i].crossSlope))/(3.6 * Math.abs(leftSide[i+1].stationing - leftSide[i].stationing));
            
            if(Math.round(calculatedRelativeVerticalSpeed*1000)/1000 > relativeVerticalSpeed)
            {
                leftSide[i].error = true;
                leftSide[i+1].error = true;
            }
        }
    }

    for(let i = 0; i < rightSide.length-1; i++)
    {
        let objectBackward = geometry.find(obj => obj.startStationing <= rightSide[i].stationing && obj.endStationing >= rightSide[i].stationing);
        let objectForward = geometry.find(obj => obj.startStationing <= rightSide[i+1].stationing && obj.endStationing >= rightSide[i+1].stationing);
        let firstRadius;
        let secondRadius;

        if(objectForward.type === "Rettlinje") firstRadius = 0;
        else if(objectForward.type === "Sirkelbue") firstRadius = objectForward.firstRadius;
        else if(objectForward.type === "Klotoide") firstRadius = Math.max(Math.abs(objectForward.firstRadius), Math.abs(objectForward.secondRadius));

        if(objectBackward.type === "Rettlinje") secondRadius = 0;
        else if(objectBackward.type === "Sirkelbue") secondRadius = objectBackward.firstRadius;
        else if(objectBackward.type === "Klotoide") secondRadius = Math.max(Math.abs(objectBackward.firstRadius), Math.abs(objectBackward.secondRadius));

        let objectSpeed = speedlimit + speedAddition + calculateSpeedProfileAddition(designClass, Math.max(firstRadius, secondRadius));
        if(Math.abs(rightSide[i+1].stationing - rightSide[i].stationing) !== 0)
        {
            let calculatedRelativeVerticalSpeed = (objectSpeed * wheelbase * Math.abs(rightSide[i+1].crossSlope - rightSide[i].crossSlope))/(3.6 * Math.abs(rightSide[i+1].stationing - rightSide[i].stationing));
            
            if(Math.round(calculatedRelativeVerticalSpeed*1000)/1000 > relativeVerticalSpeed)
            {
                rightSide[i].error = true;
                rightSide[i+1].error = true;
            }
        }
    }
    // #region

    
    return [leftSide, rightSide];
}